// ArChat Language Extension
// Created: 13-03-2026 00:00:00
// Author: SIVOL® - Aldo Frias - Argentina

import { translationsEn } from './translations.en.js';
import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsPl = {
  ...translationsEn,
  'common.loading': 'Ładowanie…',
  'common.cancel': 'Anuluj',
  'common.confirm': 'Potwierdź',
  'common.close': 'Zamknij',
  'common.sending': 'Wysyłanie...',
  'common.language': 'Język',
  'home.language': 'Język',
  'app.install': 'Zainstaluj ArChat',
  'login.title': 'Zaloguj się',
  'register.pageTitle': 'Utwórz konto',
  'onboarding.welcome_title': 'Witamy w ArChat®',
  'onboarding.step1_description': 'Zaproś pierwszy kontakt',
  'onboarding.step2_description': 'Wyślij pierwszą wiadomość',
  'onboarding.explore_archat': 'Odkrywaj ArChat®',
  'auth.invalid_credentials': 'Nieprawidłowa nazwa użytkownika lub hasło.',
  'auth.user_not_found': 'Nie znaleziono użytkownika.',
  'auth.user_inactive': 'Twoje konto jest nieaktywne. Skontaktuj się z administratorem.',
  'auth.captcha_failed': 'Niepoprawny CAPTCHA. Sprawdź odpowiedź.',
  'auth.generic_error': 'Wystąpił błąd. Spróbuj ponownie.',
  'auth.password_mismatch': 'Hasła nie są zgodne.',
  'auth.rate_limit': 'Zbyt wiele prób. Poczekaj chwilę i spróbuj ponownie.',
  'contacts.no_contacts': 'Brak kontaktów',
  'contacts.invite_contact': 'Zaproś kontakt',
  'contacts.empty.title': 'Nie masz jeszcze kontaktów',
  'contacts.empty.message': 'Wyślij zaproszenie, aby rozpocząć pierwszy czat.',
  'contacts.empty.invite_button': 'Zaproś kontakt',
  'profile.title': 'Mój profil',
  'profile.edit': 'Edytuj',
  'profile.save': 'Zapisz zmiany',
  'profile.cancel': 'Anuluj',
  'profile.language': 'Język',
  'menu.contacts': 'Kontakty',
  'menu.dashboard': 'Pulpit',
  'menu.help': 'Pomoc',
  'menu.logout': 'Wyloguj',
  'menu.files': 'Moje pliki',
  'reviews.menu_title': 'Recenzje',
  'reviews.rate_archat': 'Oceń ArChat',
  'reviews.my_review': 'Moja recenzja',
  'menu.profile': 'Mój profil',
  'menu.settings': 'Ustawienia',
  'profile.my_profile': 'Mój profil',
  'profile.status': 'Stan',
  'profile.invite_email': 'Zaproś kontakt e-mailem',
  'profile.sent_invitations': 'Wysłane zaproszenia',
  'profile.users': 'Użytkownicy',
  'profile.settings': 'Ustawienia',
  'profile.appearance': 'Wygląd',
  'profile.logout': 'Wyloguj',
  'navbar.contacts': 'Kontakty',
  'navbar.status': 'Stan',
  'contacts.available': 'Dostępny',
  'contacts.controls.filter.available': 'Dostępni',
  'contacts.controls.sort.status': 'Stan',
  'invitation.title': 'Zaproś kontakt e-mailem',
  'invitation.list.title': 'Wysłane zaproszenia',
  'invitations.pending.title': 'Oczekujące zaproszenia',
  'invitations.sent.title': 'Wysłane zaproszenia',
  'contacts.title': 'Kontakty',
  'contacts.search': 'Szukaj kontaktu',
  'contacts.sort': 'Sortuj',
  'contacts.sortByName': 'Po nazwie',
  'contacts.sortByStatus': 'Po statusie',
  'contacts.sortByRecent': 'Najnowsze',
  'contacts.filter': 'Filtruj',
  'contacts.filterAll': 'Wszystkie',
  'contacts.filterAvailable': 'Dostępni',
  'contacts.filterInvited': 'Zaproszeni',
  'contacts.filterBlocked': 'Zablokowani',
  'contacts.pending_invitations': 'Oczekujące zaproszenia',
  'contacts.status.invitation_sent': 'Zaproszenie wysłane',
  'contacts.conversations': 'Konwersacje',
  'contacts.search_contact': 'Szukaj kontaktu',
  'contacts.controls.search_placeholder': 'Szukaj kontaktu...',
  'contacts.controls.search_label': 'Szukaj kontaktu',
  'contacts.controls.sort_label': 'Sortowanie',
  'contacts.controls.filter_label': 'Stan',
  'contacts.controls.hide_non_favorites': 'Ukryj kontakty nienależące do ulubionych',
  'contacts.controls.show_all': 'Pokaż wszystkie kontakty',
  "menu.open": "Menu",
  'contacts.status': 'Stan',
  'dashboard.title': 'Panel',
  'dashboard.planUsage': 'Wykorzystanie planu',
  'dashboard.filesSummary': 'Moje pliki',
  'dashboard.promotions': 'Promocje',
  'dashboard.sessions': 'Aktywne sesje',
  'dashboard.explore': 'Odkrywaj',
  'dashboard.noSessions': 'Brak aktywnych sesji',
  'dashboard.welcomeTitle': 'Witamy w ArChat®',
  'dashboard.welcomeSubtitle': 'Rozmawiaj w dowolnym języku.',
  'dashboard.stepInvite': 'Krok 1: zaproś pierwszy kontakt',
  'dashboard.stepMessage': 'Krok 2: wyślij pierwszą wiadomość',
  'dashboard.inviteContact': 'Zaproś kontakt',
  'dashboard.exploreArChat': 'Poznaj ArChat',
  'dashboard.promotionsTitle': 'Promocje',
  'dashboard.promotionsText': 'Skrót programu poleceń i nagród.',
  'dashboard.viewPromotions': 'Zobacz promocje',
  'dashboard.usageTitle': 'Wykorzystanie planu',
  'dashboard.sessionsTitle': 'Aktywne sesje',
  'dashboard.sessionsEmpty': 'Brak aktywnych sesji',
  'dashboard.filesTitle': 'Moje pliki',
  'dashboard.viewFiles': 'Moje pliki',
  'dashboard.noBlocks': 'Brak aktywnych bloków. Włącz co najmniej jeden w ustawieniach.',
  'dashboard.openSettings': 'Otwórz ustawienia',
  'dashboard.goToContacts': 'Przejdź do kontaktów',
  'dashboard.filesVisible': 'Widoczne pliki',
  'dashboard.filesSampleNote': 'Liczba z pierwszej strony (do 500+).',
  'dashboard.card.contacts': 'Kontakty',
  'navbar.users': 'Użytkownicy',
  'contacts.controls.sort.name': 'Imię',
  'contacts.controls.sort.recent': 'Ostatnie',
  'contacts.controls.sort.manual': 'Ręcznie',
  'contacts.controls.sort.manual_drag_hint': 'Przeciągnij, aby zmienić kolejność',
  'contacts.controls.filter.all': 'Wszystkie',
  'contacts.controls.filter.invited': 'Zaproszeni',
  'contacts.controls.filter.blocked': 'Zablokowani',
  'contacts.controls.filter.favorites': 'Ulubione',
  'profile.personalInfo': 'Dane osobowe',
  'profile.photo': 'Zdjęcie profilowe',
                'notifications.bell.aria': 'Powiadomienia',
                'notifications.panel.title': 'Powiadomienia',
                'notifications.empty': 'Brak powiadomień',
                'notifications.mark_read': 'Oznacz jako przeczytane po otwarciu',
  'profile.photo.change': 'Zmień zdjęcie profilowe',
  'profile.plan.current': 'Bieżący plan',
  'common.back': 'Wróć',
  'common.backToStart': 'Wróć do strony głównej',
  'common.continue': 'Kontynuuj',
  'buttons.close': 'Zamknij',
  'common.navigation': 'Nawigacja',
  'common.favorite': 'Ulubione',
  'common.block': 'Blokuj',
  'common.user': 'Użytkownik',
  'message.new': 'Nowa wiadomość',
  'message.edit': 'Edytuj wiadomość',
  'message.edit.save': 'Zapisz edycję',
  'message.edit.cancel': 'Anuluj edycję',
  'message.translating': 'Tłumaczenie...',
  'message.translation_failed': 'Nie udało się przetłumaczyć',
  'message.not_translated': 'Tekst oryginalny',
  'message.retry_send': 'Spróbuj ponownie',
  'message.retrying': 'Ponowna próba...',
  'message.delete': 'Usuń wiadomość',
  'message.deleted_placeholder': 'Wiadomość usunięta',
  'message.edited': 'Edytowano',
  'message.edited_at': 'Edytowano',
  'message.delete_for_me.tooltip': 'Usuń dla mnie',
  'message.delete_for_me.aria': 'Usuń tę wiadomość tylko dla mnie',
  'message.delete_for_me.confirm_title': 'Usuń wiadomość',
  'message.delete_for_me.confirm_message': 'Ta wiadomość zostanie usunięta tylko z Twojego widoku.',
  'message.delete_for_everyone.tooltip': 'Usuń dla wszystkich',
  'message.delete_for_everyone.aria': 'Usuń tę wiadomość dla wszystkich uczestników',
  'message.delete_for_everyone.confirm_title': 'Usuń wiadomość dla wszystkich',
  'message.delete_for_everyone.confirm_message': 'Ta wiadomość zostanie usunięta dla Ciebie i drugiego uczestnika.',
  'message.delete_for_everyone.window_expired': 'Okno usuwania wygasło',
  'message.translation.show': 'Pokaż oryginał i tłumaczenie',
  'message.translation.hide': 'Ukryj tłumaczenie',
  'emoji.search': 'Szukaj emoji',
  'emoji.close': 'Zamknij selektor',
  'captcha.refresh': 'Wygeneruj CAPTCHA ponownie',
  'presence.unavailable': 'Statusy niedostępne',
  'presence.maintenance': 'Serwer w konserwacji',
  'status.available': 'Dostepny',
  'status.busy': 'Zajety',
  'status.in_call': 'W trakcie rozmowy',
  'status.away': 'Nieobecny',
  "status.offline": "Nieaktywny",
  'status.custom': 'Wiadomosc niestandardowa',
  'status.set_title': 'Status dostepnosci',
  'status.set_button': 'Zmien status',
  'status.placeholder': 'Wiadomosc opcjonalna (np. Na spotkaniu)',
  'presence.title': 'Status obecnosci',
  'presence.currentStatus': 'Aktualny status:',
  'presence.changeStatus': 'Zmien status',
  "presence.status.online": "W Internecie",
  'presence.status.online.title': 'Online - Widoczny dla wszystkich',
  'presence.status.online.description': 'Online: Widoczny dla wszystkich kontaktow',
  'presence.status.idle': 'Bezczynny',
  'presence.status.idle.title': 'Bezczynny - Wskazuje tymczasowa nieobecnosc',
  'presence.status.idle.description': 'Bezczynny: Wskazuje, ze jestes tymczasowo niedostepny',
  'presence.status.dnd': 'Nie przeszkadzac',
  'presence.status.dnd.title': 'Nie przeszkadzac - Wskazuje, ze wolisz nie byc przerywany',
  'presence.status.dnd.description': 'Nie przeszkadzac: Widoczny sygnal, ze wolisz nie byc przerywany',
  'presence.status.busy': 'Zajety',
  'presence.status.busy.title': 'Zajety - Niedostepny',
  'presence.status.busy.description': 'Zajety: Niedostepny',
  "presence.status.offline": "Nieaktywny",
  'presence.status.offline.title': 'Rozlaczony - Pokazuj jako offline',
  'presence.status.offline.description': 'Offline: Pokazuj jako rozlaczony',
  'presence.status.custom': 'Niestandardowy',
  'presence.status.custom.title': 'Niestandardowy - Unikalny status z emoji',
  'presence.status.custom.description': 'Niestandardowy: Unikalny status z emoji i opcjonalnym wygasnieciem',
  'presence.custom.title': 'Status niestandardowy',
  'presence.custom.status': 'Status niestandardowy',
  'presence.custom.placeholder': 'Np.: Pije kawe ☕',
  'presence.custom.emoji': 'Emoji (opcjonalnie)',
  'presence.custom.emojiHelp': 'Wybierz emoji lub wpisz je recznie',
  'presence.custom.temporary': 'Status tymczasowy (wygasa automatycznie)',
  'presence.custom.expiration': 'Data wygasniecia',
  'presence.custom.expirationHelp': 'Status wroci do "Online" po wygasnieciu',
  'presence.custom.suggestions': 'Sugestie',
  'presence.custom.preview': 'Podglad',
  'presence.custom.save': 'Zapisz status',
  'presence.custom.required': 'Status niestandardowy jest wymagany',
  'presence.custom.maxLength': 'Maksymalnie 64 znaki',
  'presence.custom.expirationRequired': 'Musisz wybrac date wygasniecia',
  'presence.custom.expirationFuture': 'Data wygasniecia musi byc w przyszlosci',
  'presence.custom.selectEmoji': 'Wybierz emoji',
  'home.access_nav': 'Dostęp do aplikacji',
  'contact.block.unblock': 'Odblokuj',
  'contact.block.block': 'Zablokuj',
  'contact.edit.title': 'Edytuj kontakt',
  'bio.view': 'Zobacz bio',
  'suggestions.title': 'Sugestie',
  'suggestions.form.title': 'Tytuł sugestii',
  'suggestions.form.message': 'Opisz swój pomysł',
  'suggestions.form.submit': 'Wyślij sugestię',
  'suggestions.send': 'Wyślij sugestię',
  'suggestions.captcha_placeholder': 'Wynik',
  'suggestions.cooldown': 'Przed wysłaniem kolejnej sugestii musisz odczekać {minutes} minut.',
  'suggestions.success_title': 'Sugestia wysłana',
  'suggestions.success_message': 'Twoja sugestia została wysłana pomyślnie. Numer śledzenia: {id}',
  'suggestions.success': 'Dziękujemy za sugestię. Nasz zespół ją sprawdzi.',
  'suggestions.success.title': 'Dziękujemy za sugestię!',
  'suggestions.success.reference': 'Numer referencyjny',
  'suggestions.success.review': 'Nasz zespół przeanalizuje Twój pomysł.',
  'suggestions.success.email': 'Wysłaliśmy również e-mail z potwierdzeniem.',
  'suggestions.success.copy': 'Kopiuj',
  'suggestions.success.copied': 'Numer referencyjny skopiowany',
  'suggestions.form.required': 'Tytuł i wiadomość są wymagane.',
  'suggestions.error': 'Nie udało się wysłać. Spróbuj ponownie.',
  'suggestions.sendSuccess': 'Twoja sugestia została wysłana pomyślnie.',
  'suggestions.sendError': 'Nie udało się wysłać sugestii. Spróbuj ponownie.',
  'suggestions.sent': 'Sugestia została wysłana pomyślnie.',
  'suggestions.new': 'Nowa sugestia',
  'suggestions.empty': 'Nie wysłano jeszcze żadnych sugestii.',
  'suggestions.admin_note': 'Notatka zespołu',
  'suggestions.status.pending': 'Oczekująca',
  'suggestions.status.reviewed': 'Przejrzana',
  'suggestions.status.planned': 'Zaplanowana',
  'suggestions.status.implemented': 'Wdrożona',
  'suggestions.status.rejected': 'Odrzucona',
  'errors.suggestionSend': 'Nie udało się wysłać sugestii. Spróbuj ponownie.',
  'help.title': 'Pomoc ArChat®',
  'help.howWorks.title': 'Jak działa ArChat®',
  'help.languages.title': 'Języki',
  'help.languages.point1': 'Obsługa {count} języków.',
  'help.languages.point2': 'Wizualny selektor języka z flagami.',
  'notifications.title': 'Powiadomienia',
  'notifications.empty': 'Brak powiadomień',
  'errors.generic': 'Wystąpił nieoczekiwany błąd.',
  'errors.network': 'Błąd połączenia. Spróbuj ponownie.',
  'errors.required': 'To pole jest wymagane.',
  'promotions.invite.message': 'Zapraszam Cię do ArChat — mów w dowolnym języku. Oboje zyskujemy korzyści.',
  'promotions.progress.pending': 'Masz oczekujące zaproszenia do odblokowania nagród.',
  'promotions.progress.in_progress': 'Twoje zaproszenia są w trakcie realizacji: nagrody aktywują się po prawdziwej rozmowie.',
  'promotions.progress.remaining': 'Aby otrzymać nagrodę, potrzebujesz jeszcze {count} rozmowy.',
  'promotions.progress.sent_count': 'Wysłano',
  'promotions.progress.pending_count': 'Aż do',
  'promotions.progress.in_progress_count': 'W toku',
  'promotions.progress.completed_count': 'Zakończony',
  'promotions.banner.empty': 'Zacznij teraz: zaproś kontakty i odblokuj korzyści.',
  'promotions.banner.pending': 'Masz oczekujące zaproszenia: przeprowadź prawdziwą rozmowę i zdobądź nagrody.',
  'promotions.banner.reward': 'Już odblokowałeś nagrody! Zapraszaj dalej, aby zwiększyć swoje zyski.',
  'promotions.cta.copy': 'Skopiuj wiadomość i link',
  'promotions.cta.copied': 'Wiadomość skopiowana',
  'promotions.cta.copy_error': 'Nie udało się skopiować wiadomości',

  'promotions.title': 'Promocje i nagrody',
  'promotions.subtitle': 'Zaproś kontakty i odblokuj korzyści poprzez rzeczywiste użytkowanie.',
  'promotions.how_it_works': 'Jak to działa',
  'promotions.step1': 'Zaproś kontakt ze swojego profilu.',
  'promotions.step2': 'Kiedy akceptują i rozmawiają z prawdziwą interakcją, jest to automatycznie weryfikowane.',
  'promotions.step3': 'Nagroda zostanie przyznana, a Twoje postępy zostaną zaktualizowane.',
  'promotions.rewards.title': 'Nagrody',
  'promotions.reward.invite': 'Nagroda za każde potwierdzone polecenie.',
  'promotions.reward.milestone': 'Premie za kamienie milowe rozwoju.',
  'promotions.reward.ranking': 'Widoczność w rankingu najlepszych budowniczych sieci.',
  'promotions.progress.title': 'Twój postęp',
  'promotions.progress.sent': 'Wysłano',
  'promotions.cta.invite': 'Zaproś do kontaktu',
  'promotions.banner': 'Aktywuj promocje: zapraszaj i zdobywaj nagrody za rzeczywiste wykorzystanie.',
  'promotions.modal.title': 'Program promocyjny',
  'promotions.modal.body': 'Zdobądź +10 000 znaków za każde potwierdzone zaproszenie.\\\\nZaproś już dziś i odblokuj nagrody.',
  'promotions.modal.cta': 'Zobacz promocje',
  'login.slogan': 'Rozmowy bez granic!',
  'login.username': 'Nazwa użytkownika',
  'login.password': 'Hasło',
  'login.submit': 'Zaloguj się',
  'login.loading': 'Ładowanie...',
  'login.autoRegister.title': 'Automatyczna rejestracja',
  'login.autoRegister.description': 'Jeśli nie masz konta, wpisz nazwę użytkownika, hasło i e-mail. Konto zostanie utworzone automatycznie, a na e-mail otrzymasz link potwierdzający.',
  'login.forgotPassword': 'Zapomniałeś hasła?',
  'login.passwordRecovery.title': 'Odzyskiwanie hasła',
  'login.passwordRecovery.description': 'Wpisz adres e-mail, aby otrzymać link do odzyskania hasła.',
  'login.passwordRecovery.emailLabel': 'E-mail',
  'login.passwordRecovery.emailPlaceholder': 'Wpisz swój e-mail',
  'login.passwordRecovery.emailHelp': 'Link odzyskiwania zostanie wysłany na Twój e-mail',
  'login.passwordRecovery.send': 'Wyślij',
  'login.passwordRecovery.success': 'Link odzyskiwania został wysłany na Twój e-mail. Sprawdź skrzynkę.',
  'login.passwordRecovery.successTitle': 'E-mail wysłany',
  'login.passwordRecovery.successMessage': 'Wysłaliśmy wiadomość z instrukcjami resetowania hasła.\nSprawdź skrzynkę i folder spam. Link może dotrzeć po kilku minutach.',
  'login.passwordRecovery.devExplanation': 'W trybie deweloperskim e-mail nie trafia do skrzynki; jest zapisywany do podglądu. Użyj „Wyświetl e-mail”, aby zobaczyć treść i link.',
  'login.passwordRecovery.devSinkNotice': '⚠️ Tryb deweloperski: ta wiadomość NIE została wysłana na Twoją skrzynkę. Użyj „Wyświetl e-mail”, aby otworzyć wygenerowaną wiadomość i skorzystać z linku.',
  'login.passwordRecovery.invalidEmail': 'Wpisz prawidłowy adres e-mail',
  'login.error.invalidPassword': 'Nieprawidłowe hasło',
  'auth.require_email': 'Aby dokończyć rejestrację, wymagany jest e-mail. Wpisz swój adres e-mail.',
  'auth.tenant_mismatch': 'Twoje konto nie należy do tego środowiska. Skontaktuj się z administratorem.',
  'auth.account_blocked': 'Konto jest nieaktywne. Wpisz swój e-mail, aby je ponownie aktywować.',
  'auth.device_limit_reached': 'Osiągnięto limit urządzeń. Wyloguj się na innym urządzeniu lub ulepsz plan.',
  'auth.login.device_limit.title': 'Osiągnięto limit sesji lub urządzeń',
  'auth.login.device_limit.body': 'Twój plan pozwala na ograniczoną liczbę aktywnych sesji lub urządzeń. Wyloguj się na innym urządzeniu lub zamknij inną aktywną sesję, a następnie spróbuj ponownie.',
  'auth.password_incorrect': 'Hasło jest nieprawidłowe.',
  'auth.login.password_error_title': 'Nieprawidłowe hasło',
  'auth.login.password_attempts_hint': 'Masz 3 próby na poprawne wpisanie hasła. Jeśli je przekroczysz, będziesz musiał zresetować hasło.',
  'auth.login.password_attempts_exhausted_title': 'Osiągnięto limit prób',
  'auth.login.password_attempts_exhausted_body': 'Przekroczyłeś 3 dozwolone próby. Aby kontynuować, zresetuj hasło, korzystając z opcji „Zapomniałeś hasła?”.',
  'auth.login.go_to_reset_password': 'Przejdź do resetowania hasła',
  'auth.login.password_remaining_two': 'Pozostały Ci 2 próby.',
  'auth.login.password_remaining_one': 'Pozostała Ci 1 próba.',
  'auth.login.password_attempts_locked_inline': 'Osiągnięto maksymalną liczbę prób. Musisz zresetować hasło.',
  'auth.account_inactive_email_mismatch': 'Konto jest nieaktywne, a adres e-mail nie pasuje.',
  'auth.captcha_expired': 'Weryfikacja wygasła. Wygenerowano nową automatycznie.',
  'auth.captcha_required': 'Uzupełnij weryfikację bezpieczeństwa (CAPTCHA).',
  'auth.unauthorized': 'Nie masz uprawnień dostępu.',
  'auth.method_not_allowed': 'Metoda niedozwolona.',
  'auth.invalid_data': 'Nieprawidłowe dane.',
  'auth.credentials_required': 'Wymagana jest nazwa użytkownika i hasło.',
  'auth.csrf_invalid': 'Nieprawidłowa sesja. Odśwież stronę i spróbuj ponownie.',
  'auth.username_taken': 'Ta nazwa użytkownika jest już zarejestrowana. Zaloguj się lub wybierz inną.',
  'auth.username_unavailable': 'Ta nazwa użytkownika jest niedostępna.',
  'auth.nick_no_spaces': 'Pseudonimy nie mogą zawierać spacji.',
  'auth.password_too_short': 'Hasło musi mieć co najmniej 6 znaków.',
  'auth.confirm_success': 'Konto potwierdzone. Przekierowywanie do logowania...',
  'auth.confirm_already_active': 'Twoje konto jest już aktywne. Możesz się zalogować.',
  'auth.reset_sent': 'Jeśli adres e-mail jest zarejestrowany, otrzymasz instrukcje resetowania hasła.',
  'auth.reset_token_invalid': 'Nieprawidłowy lub brakujący link.',
  'auth.reset_token_expired': 'Ten link wygasł. Poproś o nowy w opcji „Zapomniałeś hasła?”.',
  'auth.reset_done': 'Hasło zaktualizowane. Możesz się teraz zalogować.',
  'auth.reset_fatal': 'Błąd zapisu. Spróbuj ponownie później.',
  'resetPassword.page.title': 'Nowe hasło',
  'resetPassword.page.description': 'Wpisz nowe hasło (co najmniej 6 znaków).',
  'resetPassword.newPassword': 'Nowe hasło',
  'resetPassword.newPasswordPlaceholder': 'Co najmniej 6 znaków',
  'resetPassword.submit': 'Resetuj hasło',
  'resetPassword.success': 'Hasło zaktualizowane. Przekierowywanie do logowania...',
  'resetPassword.backToLogin': 'Powrót do logowania',

  'account.delete.section_title': 'Usuń konto',
  'account.delete.description': 'Usunięcie konta trwale usunie wszystkie dane, wiadomości, kontakty i ustawienia. Tej operacji nie można cofnąć.',
  'account.delete.button': 'Usuń moje konto',
  'accountDeletion.title': 'Usunięcie konta i danych',
  'accountDeletion.description': 'Poproś o usunięcie konta ArChat i powiązanych danych.',
  'accountDeletion.openRequest': 'Poproś o usunięcie konta i danych',
  'account.delete.confirm_title': 'Usuń konto',
  'account.delete.confirm_message': 'Czy na pewno chcesz usunąć konto? Na skrzynkę zostanie wysłany e-mail z potwierdzeniem. Usunięcie jest trwałe i nieodwracalne.',
  'account.delete.email_sent_title': 'E-mail wysłany',
  'account.delete.email_sent': 'Wysłaliśmy e-mail z potwierdzeniem. Sprawdź skrzynkę i kliknij link, aby potwierdzić usunięcie.',
  'account.delete.error': 'Nie udało się przetworzyć żądania. Spróbuj ponownie.',
  'account.delete.confirm_page_title': 'Potwierdź usunięcie konta',
  'account.delete.confirm_page_desc': 'Zamierzasz trwale usunąć konto ArChat. Wszystkie dane, wiadomości, kontakty i ustawienia zostaną usunięte. Tej operacji nie można cofnąć.',
  'account.delete.confirm_final_button': 'Tak, trwale usuń moje konto',
  'account.delete.cancel_go_back': 'Anuluj i wróć',
  'account.delete.done_title': 'Konto usunięte',
  'account.delete.done_message': 'Twoje konto zostało usunięte. Wszystkie dane zostały usunięte.',
  'account.delete_token_expired': 'Link do usunięcia wygasł lub jest nieważny. Poproś o nowy w profilu.',
  'account.delete_token_invalid': 'Nieprawidłowy lub brakujący link usunięcia.',
  'account.delete_email_failed': 'Nie udało się wysłać e-maila z potwierdzeniem. Spróbuj później.',
  'account.delete_error': 'Błąd podczas usuwania. Spróbuj później.',

  'mail.send_failed': 'Nie udało się wysłać e-maila odzyskiwania. Sprawdź konfigurację SMTP lub spróbuj później.',
  'auth.register_success_email_sent': 'Konto utworzone pomyślnie. Wysłano e-mail potwierdzający. Sprawdź skrzynkę (i spam) i kliknij link, aby aktywować konto.',
  'auth.register_success_email_pending': 'Konto utworzone pomyślnie, ale wystąpił problem z wysłaniem e-maila potwierdzającego. Token aktywacji nadal jest ważny. Skontaktuj się z administratorem lub poproś o nowy e-mail.',
  'auth.email_not_verified': 'Musisz potwierdzić e-mail, aby aktywować konto.',
  'auth.email_not_verified_title': 'Konto oczekuje na potwierdzenie',
  'auth.email_send_failed': 'Nie udało się wysłać e-maila. Spróbuj ponownie lub zmień adres e-mail.',
  'auth.email_send_failed_title': 'Nie udało się wysłać e-maila',
  'auth.register.email_failed.title': 'Konto utworzone',
  'auth.register.email_failed.message': 'Konto zostało utworzone, ale wystąpił problem z wysłaniem e-maila potwierdzającego. Sprawdź spam lub poproś o nową wiadomość.',
  'auth.register.success.title': 'Konto utworzone',
  'auth.register.success.message': 'Konto utworzone pomyślnie. Wysłano e-mail potwierdzający. Sprawdź skrzynkę (i spam) i kliknij link, aby aktywować konto.',
  'auth.resend_sent': 'E-mail potwierdzający wysłany ponownie.',
  'auth.resend_activation': 'Wyślij ponownie e-mail aktywacyjny',
  'auth.resend_email': 'Wyślij e-mail ponownie',
  'auth.retry_resend': 'Spróbuj ponownie',
  'auth.change_email': 'Zmień e-mail',
  'auth.ver_email': 'Wyświetl e-mail',
  'auth.already_verified': 'Konto jest już zweryfikowane.',
  'auth.confirm_email_title': 'Potwierdź e-mail',
  'auth.confirm_email_text': 'Link aktywacyjny zostanie wysłany na:',
  'auth.confirm_email_edit': 'Edytuj',
  'auth.confirm_email_confirm': 'Potwierdź',
  'auth.confirm_email_typo_hint': 'Czy chodziło o ***@{suggestion}?',
  'brand.slogan': 'Siła bycia zrozumianym, niezależnie od języka',
  "brand.appName": "ArChat®",
  "brand.name": "ArChat®",
  "home.title": "ArChat®",
  'home.slogan': 'Siła bycia zrozumianym, niezależnie od języka',
  'home.tagline': 'Wiadomości z automatycznym tłumaczeniem',
  'home.login': 'Zaloguj się',
  'home.register': 'Utwórz konto',
  'terms.title': 'Regulamin',
  'terms.accept': 'Akceptuję i kontynuuję',
  'terms.reject': 'Odrzuć',
  'terms.rejectShort': 'Nie akceptuję',
  'terms.readAndAccept': 'Przeczytałem(-am) i akceptuję regulamin',
  'terms.cancel': 'Anuluj',
  'register.pageSubtitle': 'Wpisz swoje dane, aby utworzyć konto.',
  'register.submitLabel': 'Utwórz konto',
  'register.confirm_title': 'Potwierdź konto',
  'register.confirm_message': 'Za chwilę utworzysz konto:',
  'register.confirm': 'Potwierdź',
  'register.creatingAccount': 'Tworzenie konta…',
  'register.login_link': 'Masz już konto?',
  'register.password_hint': 'Minimum 6 znaków',
  'register.checking': 'Sprawdzanie…',
  'register.username_taken': 'Ta nazwa użytkownika jest już zajęta.',
  'register.available': 'Dostępna',
  'register.emailAlreadyExists': 'Ten adres e-mail jest już zarejestrowany.',
  'register.continue': 'Kontynuuj',
  'login.demo.title': 'Dostęp demo',
  'login.demo.credentials': 'Użytkownik: demo / Hasło: demo',
  'login.email.placeholder': 'Wpisz e-mail, aby potwierdzić konto',
  'login.email.help': 'Link potwierdzający zostanie wysłany na Twój e-mail',
  'app.install_ios_hint': 'Aby zainstalować: Udostępnij > Dodaj do ekranu głównego',
  'common.edit': 'Edytuj',
  'common.on': 'Wł.',
  'common.off': 'Wył.',
  'common.changeUser': 'Zmień użytkownika',
  'common.refresh': 'Odśwież',
  'common.request_id_label': 'Identyfikator żądania',
  'login.email.invalid': 'Wpisz prawidłowy adres e-mail',
  'system.processing': 'Przetwarzanie...',
  'captcha.solve': 'Rozwiąż CAPTCHA poprawnie',
  'captcha.generateError': 'Błąd generowania CAPTCHA. Odśwież stronę.',
  'captcha.label': 'Weryfikacja bezpieczeństwa',
  'security.verification_title': 'Weryfikacja bezpieczeństwa',
  'security.captcha_question': 'Pytanie weryfikacyjne',
  'security.enter_answer': 'Wpisz odpowiedź',
  'captcha.description': 'Rozwiąż działanie, aby kontynuować.',
  'captcha.required': 'Musisz podać odpowiedź CAPTCHA, aby kontynuować.',
  'captcha.incorrect': 'Odpowiedź CAPTCHA jest nieprawidłowa.',
  'captcha.placeholder': 'Wpisz odpowiedź',
  'captcha.questionFormat': 'Ile to {a} + {b}?',
  'menu.conversations': 'Rozmowy',
  'menu.admin': 'Administracja',
  'menu.promotions': 'Promocje',
  "navbar.profile": "Mój profil",
  "navbar.settings": "Konfiguracja",
  "navbar.logout": "Wychodzić",
  'navbar.no_blocked_users': 'Brak zablokowanych użytkowników',
  'navbar.blocked_users_title': 'Zablokowani użytkownicy',
  'contacts.blocked_users_title': 'Zablokowani użytkownicy',
  'contacts.country_label': 'Kraj',
  'contacts.not_reported': 'Nie podano',
  "navbar.user_fallback": "Użytkownik {id}",
  "navbar.open_guide": "Przewodnik",
  "help.view_initial_guide": "Zobacz wstępny przewodnik",
  "help.how_archat_works": "Jak działa ArChat®",
  "help.registration": "Nagrywać",
  "help.private_invitations": "Prywatne zaproszenia",
  "help.messaging": "Wiadomości",
  "help.security": "Bezpieczeństwo",
  "invitation.quick_button": "Zaproś do kontaktu",
  "onboarding.title": "Witamy w ArChat®",
  "onboarding.subtitle": "Komunikuj się z kimkolwiek, w dowolnym języku.",
  "onboarding.step1.label": "Krok 1",
  "onboarding.step1.text": "Zaproś swój pierwszy kontakt",
  "onboarding.step2.label": "Krok 2",
  "onboarding.step2.text": "Wyślij swoją pierwszą wiadomość",
  "onboarding.actions.invite": "Zaproś do kontaktu",
  "onboarding.actions.explore": "Poznaj ArChat®",
  "onboarding.welcome_subtitle": "Komunikuj się z kimkolwiek, w dowolnym języku.",
  "onboarding.step1": "Krok 1",
  "onboarding.step1_title": "Krok 1",
  "onboarding.step2": "Krok 2",
  "onboarding.step2_title": "Krok 2",
  "onboarding.invite_contact": "Zaproś do kontaktu",
  "referral.promo": "Zaproś i wygraj 10 000 znaków",
  "referral.stats.sent": "Wysłano",
  "referral.stats.accepted": "Przyjęty",
  "referral.stats.rewards": "Nagrody",
  "referral.reward.pending": "Kolczyk",
  "referral.reward.granted": "Wypełniony",
  "referral.reward.invalid": "Nieważny",
  "referral.reward.in_progress": "W użyciu",
  "referral.limit.reached": "Osiągnięto limit nagród",
  "referral.waiting.usage": "+10 000 znaków każdy, gdy Ty i Twój gość wyślecie co najmniej jedną prawdziwą wiadomość tekstową na tym samym czacie (sprawdzone przez serwer).",
  "common.avatar": "Awatara",
  "common.requiredFields": "Wypełnij wszystkie wymagane pola.",
  "profile.founderBadge": "Założyciel #{pozycja}/{limit}",
  "profile.founderTooltip": "Członek założyciel – Cena zamrożona na całe życie, dopóki subskrypcja pozostaje aktywna",
  "profile.founderMember": "Członek założyciel",
                'profile.founderHeaderBadge': '★ Założyciel #{position}/150',
                'profile.camera.access_denied': 'Brak dostępu do aparatu. Sprawdź uprawnienia.',
  "profile.save.success": "Twój profil został pomyślnie zaktualizowany.",
  "profile.save.success.title": "Zaktualizowany profil",
  "profile.update.success.title": "Zaktualizowany profil",
  "profile.update.success.message": "Twoje zmiany zostały pomyślnie zapisane.",
  "profile.save.error": "Nie można zaktualizować profilu. Spróbuj ponownie.",
  "profile.save.error.title": "Zapisz błąd",
  "profile.nick": "Nazwa użytkownika",
  "profile.nick.help": "Twój unikalny identyfikator w systemie",
  "profile.nick.readonly": "Nie można modyfikować nazwy użytkownika",
  "profile.nick.readonly.help": "Nazwa użytkownika jest unikalna i nie można jej modyfikować",
  "profile.email.readonly": "Nie można modyfikować adresu e-mail",
  "profile.email.readonly.help": "Adres e-mail jest unikalny i nie można go modyfikować",
  "profile.name": "Prawdziwe imię",
  "profile.lastname": "Nazwisko",
  "profile.alias": "Alias",
  "profile.email": "E-mail",
  "profile.phone": "Telefon",
  "profile.country": "Kraj",
  "profile.country.select": "Wybierz kraj",
  "profile.biography": "Biografia",
  'bio.modal.original': 'Oryginał',
  'bio.modal.translation': 'Tłumaczenie',
  'bio.modal.empty': 'Ten kontakt nie ma biografii.',
  'bio.modal.translating': 'Tłumaczenie...',
  'bio.modal.translation_error': 'Nie udało się przetłumaczyć biografii.',
  'attachment.unnamed_file': 'Plik',
  'auth.login_error.default_title': 'Błąd dostępu',
  'auth.login_error.default_message': 'Nie można się zalogować.',
  'profile.notifications.sound': 'Notification sound',
  "profile.notifications.sound_desc": "Odtwarzaj dźwięk, gdy nadejdą ważne wiadomości lub alerty",
  "profile.invitations.title": "Zaproszenia",
  "profile.invitations.validated": "Sprawdzone zaproszenia",
  "profile.invitations.nextBadge": "Następne osiągnięcie",
  "profile.invitations.progress": "Postęp",
  "profile.invitations.achievement": "Osiągnięcie",
  "profile.invitations.topInviterAchieved": "Osiągnięto maksymalną liczbę zapraszających",
  "profile.invitations.badges.networkBuilder": "Konstruktor sieci",
  "profile.invitations.badges.topInviter": "Maksymalny zapraszający",
  "profile.invitations.achievement.networkBuilderMessage": "Zaprosiłeś 20 użytkowników na ArChat.",
  "profile.invitations.achievement.topInviterMessage": "Zaprosiłeś 50 użytkowników na ArChat.",
  "profile.plan.title": "Abonament",
  "profile.plan.expires": "wygasa",
  "profile.plan.loading_info": "Ładowanie informacji o planie...",
  "profile.plan.valid_until": "Ważne do:",
  "profile.plan.active_since": "Aktywny od:",
  "profile.plan.active_badge": "✓ Aktywny",
  'profile.plan.free.description': 'Free plan with limitations. Upgrade to PRO for full access.',
  'profile.plan.pro.description': 'You have full access to all features.',
  "profile.plan.upgrade.button": "Przejdź na wersję PRO",
  'profile.plan.upgrade.hint': 'Access all features without limits',
  "profile.manage_plan": "Zarządzaj planem",
  "plan.current_plan": "Aktualny plan",
  "plan.current": "Actual",
  "plan.footer_prefix": "Plan:",
  "plan.upgrade_to_pro": "Przejdź na wersję PRO",
  "plan.upgrade_to_foundation": "Przejdź na FUNDACJĘ",
  "plan.payment_coming": "Płatność za pomocą Paddle będzie dostępna wkrótce. Tutaj możesz zmienić plany.",
  "plan.payment_coming_title": "Wkrótce",
  "plan.foundation_full": "Limit FUNDACJI jest pełny (150 założycieli). Możesz wybrać PRO.",
  "plan.sold_out": "Wyczerpany",
  "plan.founder_spots_remaining": "Dostępne tylko miejsca: {count}",
  "plan.founders_occupied": "zajęci założyciele",
  "plan.upgrade_not_allowed": "Tylko użytkownicy z planem DARMOWYM mogą poprosić o aktualizację.",
  'plan.free_contacts': 'Do 2 kontaktów',
  "plan.free_no_files": "Sin archivos",
  "plan.free_retention": "Historial 30 días",
  "plan.free_characters_month": "30,000 characters / month",
  'plan.pro_characters_month': '300 000 znaków / miesiąc',
  "plan.pro_files": "Archivos hasta 50MB",
  "plan.pro_export": "Exportación",
  "plan.founder_support": "Prioridad soporte",
  "plan.founder_badge": "Badge fundador",
  "founder.title": "FUNDACJA (Założyciel)",
  "founder.subtitle": "Wspierasz projekt od początku za dożywotnią cenę.",
  "founder.whatIs": "Pierwszych 150 użytkowników otrzyma plan FOUNDATION po obniżonej cenie na całe życie.",
  "founder.howItWorks": "Twój poziom założyciela zależy od twojej pozycji (od 1 do 150).",
  "founder.benefitsTitle": "Korzyści",
  'founder.benefitPrice': '$15 / miesiąc (stawka Founder)',
  "founder.benefitFeatures": "Zawiera wszystkie funkcje planu PRO.",
  "founder.limit": "Jest tylko 150 miejsc dla Założycieli.",
  "founder.cancelRule": "Jeśli anulujesz subskrypcję, utracisz status Założyciela.",
  "founder.rejoinRule": "Jeśli ponownie pojawi się wolne miejsce, możesz je ponownie aktywować i automatycznie ponownie zostać Założycielem.",
  "founder.tiers.title": "Poziomy założycielskie",
  "founder.tiers.legendary.name": "LEGENDARNY Założyciel",
  "founder.tiers.legendary.range": "Pozycja 1–25",
  "founder.tiers.legendary.desc": "Jako pierwszy wspomógł projekt. Maksymalny priorytet historyczny.",
  "founder.tiers.early.name": "WCZESNY Założyciel",
  "founder.tiers.early.range": "Pozycja 26–75",
  "founder.tiers.early.desc": "Wczesne wsparcie ze szczególnym uznaniem.",
  "founder.tiers.founder.name": "założyciel",
  "founder.tiers.founder.range": "Pozycja 76–150",
  "founder.tiers.founder.desc": "Liczba założycieli w obrębie 150 miejsc.",
  "founder.whatIsLink": "Kim jest Założyciel?",
  "founder.viewTiers": "Zobacz Poziomy założyciela",
  'billing.change_plan': 'Zmień plan',
  "billing.usage.title": "Planuj wykorzystanie",
  "billing.usage.users": "Użytkownicy",
  "billing.usage.messages": "Wiadomości (dzisiaj)",
  "billing.usage.invitations": "Zaproszenia (dzisiaj)",
  "billing.usage.messages_month": "Wiadomości w tym miesiącu",
  "billing.usage.chats": "Rozmowy",
  "billing.usage.contacts": "Łączność",
  "billing.usage.chars_month": "Znaków miesięcznie",
  "billing.usage.storage": "Używany schowek",
  "billing.usage.devices": "Podłączone urządzenia",
  'billing.usage.warning': 'You are approaching your plan limit. Upgrade to PRO for more capacity.',
  'plans.limit.reached': 'Limit osiągnięty — Zmień plan',
  "billing.loading": "Ładowanie...",
  'billing.subscription.section_title': 'Subskrypcja i rozliczenia',
  'billing.subscription.provider_note': 'Dostawca',
  'billing.subscription.paddle_active': 'Paddle (aktywny plan w aplikacji)',
  'billing.subscription.mp_action_ok': 'Prośba zapisana. Jeśli płatność się nie otworzyła, sprawdź połączenie lub spróbuj ponownie.',
  'billing.paddle.manage_subscription_button': 'Zarządzaj subskrypcją',
  'billing.paddle.portal_confirm_title': 'Portal rozliczeniowy',
  'billing.paddle.portal_confirm': 'Otworzy się bezpieczny portal Paddle, aby zaktualizować metodę płatności, faktury lub anulować subskrypcję. Kontynuować?',
  'billing.paddle.portal_opened_hint': 'Portal Paddle otwarto w nowej karcie. Odśwież profil, jeśli plan się nie zaktualizował.',
  'billing.paddle.portal_error': 'Nie można otworzyć portalu Paddle. Spróbuj później lub skontaktuj się z pomocą.',
  'billing.paddle.no_link_error': 'Brak powiązania subskrypcji Paddle na koncie. Jeśli właśnie zapłaciłeś, poczekaj na webhook lub skontaktuj się z pomocą.',
  'billing.paddle.api_not_configured': 'Brak konfiguracji Paddle API (PADDLE_API_KEY) na serwerze. Administrator musi ją ustawić.',
  "billing.descriptions.contacts": "Całkowita liczba kontaktów przechowywanych na Twoim koncie",
  "billing.descriptions.storage": "Pamięć używana do przechowywania plików i multimediów",
  "billing.descriptions.chars_month": "Znaki przetłumaczone w tym miesiącu",
  "billing.descriptions.devices": "Aktywne podłączone urządzenia",
  'billing.paddle.return_title': 'Płatność przyjęta',
  'billing.paddle.return_body': 'Jeśli dokończyłeś płatność, plan zaktualizuje się wkrótce po potwierdzeniu przez Paddle. Możesz wrócić do strony głównej.',
  'billing.paddle.verifying': 'Sprawdzanie planu…',
  'billing.paddle.not_logged_in': 'Zaloguj się, aby zobaczyć aktualny status planu.',
  'billing.paddle.plan_updated': 'Plan zaktualizowany: {plan}',
  'billing.paddle.plan_current': 'Twój obecny plan: {plan}',
  'billing.paddle.plan_current_founder': 'Jesteś teraz Founder — {plan}',
  'billing.paddle.still_free_hint': 'Jeśli nadal widzisz FREE po chwili, webhook mógł się opóźnić. Sprawdź logi backendu lub odśwież stronę.',
  'billing.paddle.pro_extra_hint': 'Możesz wrócić do strony głównej, aby korzystać z planu.',
  "profile.theme.dark": "Tryb ciemny",
  "profile.theme.light": "Tryb czyszczenia",
  "profile.theme.argentina": "Motyw Argentyny",
  "modal.title": "Kwalifikacja",
  "modal.success.title": "Sukces",
  "modal.error.title": "Błąd",
  "modal.warning.title": "Ostrzeżenie",
  "info.title": "Informacja",
  "appearance.title": "Wygląd",
  "appearance.theme.light": "Jasne",
  "appearance.theme.dark": "Ciemny",
  "theme.title": "Wydanie",
  "theme.light": "Jasne",
  "theme.dark": "Ciemny",
  "profile.photo.section": "Zdjęcie profilowe",
  "profile.preferences": "Preferencje",
  "profile.country.help": "Strefa czasowa zostanie automatycznie przypisana na podstawie wybranego kraju",
  "profile.lastname.placeholder": "Twoje nazwisko (opcjonalnie)",
  "profile.name.placeholder": "Twoje prawdziwe imię i nazwisko (opcjonalnie)",
  "profile.biography.placeholder": "Opowiedz nam o sobie...",
  "message.placeholder": "Napisz wiadomość...",
  "message.placeholderWithFile": "Wyślij plik",
  "message.sent_from_country": "Wysłane z",
  "message.sent_at_local_time": "Czas lokalny emitenta",
  "message.timezone_label": "strefa czasowa",
  "message.context_info": "Ta wiadomość zachowuje kontekst czasowy chwili, w której została wysłana.",
  "message.context_pro_hint": "Ta wiadomość ma kontekst czasowy i geograficzny dostępny w planach Pro.",
  "message.context_pro_badge": "Kontekst Pro",
  "messages.empty": "Nie ma jeszcze żadnych wiadomości",
  "messages.loading": "Ładowanie wiadomości...",
  "messages.connecting_server": "Łączę się z serwerem wiadomości...",
  "messages.pending_send_count": "Wiadomości oczekujące na dostarczenie: {count}",
  "attachment.title": "Dołącz plik",
  "attachment.close": "Zamknąć",
  "attachment.gallery": "Galeria zdjęć/wideo",
  "attachment.cameraFront": "przedni aparat",
  "attachment.cameraBack": "tylny aparat",
  "attachment.cameraWeb": "kamera internetowa",
  "attachment.selectFile": "Wybierz plik (PDF, tekst, obrazy, filmy)",
  "attachment.remove": "Wyeliminować",
  'attachments.recipientFreeBlocked.title': 'Limit planu',
  'attachments.recipientFreeBlocked.sender': 'Ten użytkownik ma plan Free i nie może otrzymywać załączników.',
  'attachments.recipientFreeBlocked.receiver': '{senderName} próbował wysłać załącznik, ale plan {planName} nie pozwala na załączniki. Polecamy wyższy plan, aby odbierać pliki.',
  'attachments.recipientFreeBlocked.upgradeCta': 'Ulepsz plan',
  "attachment.audioNotSupported": "Wiadomości audio nie są obsługiwane w aplikacji ArChat®. Proszę o wiadomość pisemną.",
  "message.audioDeprecated.title": "Wiadomości głosowe nie są obsługiwane",
  "message.audioDeprecated.message": "Ta wiadomość głosowa nie jest już obsługiwana przez ArChat®. Proszę o wiadomość pisemną.",
  "camera.title": "Kamera",
  "camera.close": "Zamknąć",
  "camera.switch": "Zmień aparat",
  "camera.capture": "Zrób zdjęcie",
  "camera.loading": "Uruchamiam kamerę...",
  "camera.retry": "Spróbować ponownie",
  "camera.error.access": "Nie można było uzyskać dostępu do aparatu. Sprawdź uprawnienia.",
  "camera.error.permission": "Odmowa uprawnień do aparatu. Zezwól na dostęp do kamery w ustawieniach swojej przeglądarki.",
  "camera.error.notFound": "Nie znaleziono dostępnej kamery.",
  "camera.error.busy": "Aparat jest używany przez inną aplikację.",
  "camera.error.constraint": "Nie można spełnić ograniczeń aparatu.",
  "profile.photo.take": "Zrób zdjęcie",
  "profile.photo.gallery": "Wybierz z galerii",
  "profile.photo.select": "Wybierz zdjęcie",
  "profile.photo.select.gallery": "Wybierz z galerii",
  "profile.photo.uploading": "Przesyłanie obrazu...",
  "profile.photo.upload.success": "Pomyślnie zaktualizowano zdjęcie profilowe",
  "profile.photo.upload.success.title": "Zaktualizowane zdjęcie",
  "profile.photo.upload.error": "Błąd podczas przesyłania zdjęcia profilowego. Spróbuj ponownie.",
  "profile.photo.upload.error.title": "Błąd podczas przesyłania zdjęcia",
  "avatar.errors.too_large": "Obraz jest za duży. Maksymalny rozmiar: 2 MB.",
  "avatar.preview.title": "Podgląd awatara",
  "profile.avatar.error_title": "Nie można zaktualizować awatara",
  "profile.avatar.error.title": "Nie można zaktualizować awatara",
  "profile.avatar.error.size": "Obraz przekracza dozwolony rozmiar. Maksymalny rozmiar wynosi 2 MB.",
  "profile.avatar.tooLarge.title": "Obraz jest za duży",
  "profile.avatar.tooLarge.message": "Zdjęcie przekracza dozwolony rozmiar. Maksymalny rozmiar wynosi 2 MB.",
  "profile.avatar.uploadError.title": "Nie można zaktualizować awatara",
  "profile.avatar.uploadError.message": "Wystąpił problem podczas przesyłania obrazu. Spróbuj ponownie.",
  "profile.saveSuccess.title": "Zaktualizowany profil",
  "profile.saveSuccess.message": "Twoje zmiany zostały pomyślnie zapisane.",
  "profile.avatar.file_too_large": "Obraz przekracza maksymalny dozwolony rozmiar (2 MB).",
  "profile.avatar.file_too_large_hint": "Wybierz jaśniejszy obraz lub zmniejsz jego rozmiar i spróbuj ponownie.",
  "profile.photo.take.front": "przedni aparat",
  "profile.photo.take.back": "tylny aparat",
  "profile.photo.take.webcam": "kamera internetowa",
  "profile.photo.camera.front": "przedni aparat",
  "profile.photo.camera.back": "tylny aparat",
  "profile.photo.camera.web": "kamera internetowa",
  "profile.photo.close": "Zamknąć",
  "profile.photo.capture": "Schwytać",
  "user.default": "Użytkownik",
  "logout.title": "Potwierdzać",
  "logout.confirm": "Czy na pewno chcesz się wylogować?",
  "block.toggle_error": "Nie można zablokować ani odblokować.",
  "contacts.search.placeholder": "Szukaj według nazwy użytkownika, imienia, nazwiska, kraju lub języka...",
  "contacts.empty": "Nie ma żadnych kontaktów",
  "contacts.empty.private.message": "Twój profil jest prywatny. Zaproś kontakty, aby rozpocząć czat.",
  "contacts.empty.private.invite_button": "Zaproś kontakt",
  "contacts.search.no_results": "Nie znaleziono żadnych kontaktów",
  "contacts.search.clear": "Pokaż wszystko",
  "contacts.nick": "Nazwa użytkownika",
  "contacts.name": "Nazwa",
  "contacts.lastname": "Nazwisko",
  "contacts.country": "Kraj",
  "contacts.language": "Język",
  "contacts.status.pending_registration": "Rejestracja w toku",
  "contacts.status.registered": "Gość - zarejestrowany",
  "contacts.status.ready_to_chat": "Gotowy do rozmowy",
  "contacts.status.active_conversation": "Aktywna rozmowa",
  "contacts.invitation.pending.title": "Oczekujące zaproszenie",
  "contacts.invitation.pending.message": "To zaproszenie oczekuje na rejestrację. Osoba kontaktowa otrzyma wiadomość e-mail umożliwiającą dokończenie rejestracji. Po zarejestrowaniu będziesz mógł z nim rozmawiać.",
  "contacts.error.no_registered": "Kontakt nie jest jeszcze zarejestrowany. Poczekaj na zakończenie rejestracji.",
  "contact.edit.alias.label": "Niestandardowy alias",
  "contact.edit.alias.placeholder": "Przykład: Juan z pracy",
  "contact.edit.alias.help": "Imię to pojawi się zamiast prawdziwego imienia",
  "contact.edit.nota.label": "Notatka osobista",
  "contact.edit.nota.placeholder": "Dodaj notatkę na temat tego kontaktu...",
  "contact.edit.nota.help": "Prywatne notatki widoczne tylko dla Ciebie",
  "contact.edit.error.noUser": "Błąd: niezidentyfikowany użytkownik",
  "contact.edit.error.noContactId": "Błąd: nie udało się zidentyfikować kontaktu",
  "contact.edit.error.save": "Błąd podczas zapisywania",
  "contact.limit.title": "Osiągnięto limit kontaktów",
  "contact.limit.message": "Plan DARMOWY pozwala na maksymalnie 2 kontakty na użytkownika. Możesz uaktualnić do wersji FOUNDATION lub PRO, aby uzyskać większą pojemność, gdy włączone jest ładowanie.",
  "contact.favorite.add": "Dodaj do ulubionych",
  "contact.favorite.remove": "Usuń z ulubionych",
  "conversation.backToContacts": "Wróć do kontaktów",
  "conversation.notFound": "Nie znaleziono rozmowy",
  "help.howWorks.step1.title": "1️⃣ Rejestracja",
  "help.howWorks.step1.point1": "Zaloguj się swoim nickiem i hasłem.",
  "help.howWorks.step1.point2": "Jeżeli nie posiadasz konta, zostanie ono utworzone automatycznie.",
  "help.howWorks.step1.point3": "Akceptujesz Regulamin w swoim języku.",
  "help.howWorks.step1.point4": "Potwierdzasz swoje konto e-mailem.",
  "help.howWorks.step2.title": "2️⃣ Zaproszenia prywatne",
  "help.howWorks.step2.point1": "Zaproś kontakty e-mailem ze swojego profilu.",
  "help.howWorks.step2.point2": "Przed rozpoczęciem zdefiniuj język i tryb konwersacji.",
  "help.howWorks.step2.point3": "Osoba kontaktowa otrzyma prywatne zaproszenie.",
  "help.howWorks.step2.point4": "Możesz sprawdzić, czy jest: Oczekujący, Zarejestrowany, Gotowy do czatu",
  "help.howWorks.step2.point5": "Nie szuka się kontaktów, są zapraszani.",
  "help.howWorks.step2.point6": "Nie szuka się kontaktów, są zapraszani.",
  "help.howWorks.step3.title": "3️⃣ Kontakty i rozmowy",
  "help.howWorks.step3.point1": "Twoje kontakty pojawiają się automatycznie, gdy:",
  "help.howWorks.step3.point2": "przyjąć zaproszenie",
  "help.howWorks.step3.point3": "albo jest rozmowa",
  "help.howWorks.step3.point4": "Móc:",
  "help.howWorks.step3.point5": "oznacz je jako ulubione ⭐",
  "help.howWorks.step3.point6": "przypisz im niestandardowe aliasy",
  "help.howWorks.step3.point7": "dodaj prywatne notatki",
  "help.howWorks.step3.point8": "blokuj je lub zarządzaj nimi",
  "help.howWorks.step3.point9": "Bez zgody nie ma porządku publicznego ani widocznych użytkowników.",
  "help.howWorks.step4.title": "4️⃣ Wiadomości z tłumaczeniem",
  "help.howWorks.step4.point1": "Zawsze pisz w swoim języku.",
  "help.howWorks.step4.point2": "System automatycznie przetłumaczy wiadomość.",
  "help.howWorks.step4.point3": "Odbiorca otrzymuje go w swoim języku.",
  "help.howWorks.step4.point4": "Możesz zobaczyć zastosowane tłumaczenie.",
  "help.howWorks.step4.point5": "Jeżeli tłumaczenie nie powiedzie się, zostanie ono automatycznie ponowione.",
  "help.howWorks.step4.point6": "ArChat® stawia na przejrzystość i znaczenie, a nie tylko na szybkość.",
  "help.privacy.title": "🔒 Prywatność i kontrola",
  "help.privacy.point1": "Twój profil jest domyślnie prywatny.",
  "help.privacy.point2": "Tylko zaproszone osoby mogą Cię widzieć i pisać do Ciebie.",
  "help.privacy.point3": "Widoczność publiczna jest opcjonalna i domyślnie wyłączona.",
  "help.privacy.point4": "Aktywne bezpieczeństwo dzięki:",
  "help.privacy.point5": "CAPTCHA",
  "help.privacy.point6": "ograniczanie szybkości",
  "help.privacy.point7": "odcisk palca",
  "help.privacy.point8": "weryfikacja e-mailowa",
  "help.privacy.point9": "Twoje rozmowy nie są publiczne ani indeksowane.",
  "help.files.title": "📎 Pliki i eksport",
  "help.files.point1": "Dołącz obrazy, filmy i dokumenty PDF.",
  "help.files.point2": "Rób zdjęcia za pomocą przedniego aparatu, tylnego aparatu lub kamery internetowej.",
  "help.files.point3": "Obrazy są automatycznie kompresowane.",
  "help.files.point4": "Podgląd przed wysłaniem.",
  "help.files.point5": "Pasek postępu podczas ładowania.",
  "help.files.point6": "Eksportuj całe rozmowy do:",
  "help.files.point7": "PDF",
  "help.files.point8": "HTML",
  "help.files.point9": "Zawiera wiadomości, obrazy i pliki.",
  "help.files.point10": "Twoje dane są Twoje.",
  "help.experience.title": "🎨 Doświadczenie użytkownika",
  "help.experience.point1": "Statusy obecności i statusy niestandardowe z emoji.",
  "help.experience.point2": "Zintegrowane emoji OpenMoji.",
  "help.experience.point3": "Wskaźniki odczytu i zapisu.",
  "help.experience.point4": "Zoptymalizowany widok mobilny równy widokowi na komputery stacjonarne.",
  "help.experience.point5": "Instalowalna aplikacja PWA.",
  "help.experience.point6": "Dwa motywy: Argentyna (jasnoniebieski/biały/złoty) i Oscuro (głęboki fiolet).",
  "help.experience.point7": "Edycja profilu bez napojów bezalkoholowych.",
  "help.experience.point8": "Wybór kraju z automatyczną strefą czasową.",
  "help.experience.point9": "Szybki dostęp do ulubionych, wyszukiwania i filtrów.",
  "help.languages.point3": "Interfejs, regulamin i e-maile dostosowane do wybranego języka.",
  "help.languages.point4": "Dwukierunkowe automatyczne tłumaczenie pomiędzy użytkownikami.",
  "help.tipsNew.title": "💡 Wskazówki dotyczące korzystania z ArChat®",
  "help.tipsNew.point1": "Zapraszaj tylko osoby, z którymi naprawdę chcesz się komunikować.",
  "help.tipsNew.point2": "Używaj aliasów i prywatnych notatek do porządkowania kontaktów.",
  "help.tipsNew.point3": "Oznacz ulubione, aby uzyskać szybki dostęp.",
  "help.tipsNew.point4": "Sprawdź tłumaczenie przed wysłaniem ważnych wiadomości.",
  "help.tipsNew.point5": "Eksportuj odpowiednie rozmowy w celu utworzenia kopii zapasowej lub pracy.",
  "help.tipsNew.point6": "Użyj ArChat®, gdy kluczowa jest przejrzystość tekstu.",
  "help.whySubscribe.title": "🚀 Dlaczego warto subskrybować ArChat®",
  "help.whySubscribe.point1": "ArChat® nie jest przeznaczony do rozmów z byle kim,",
  "help.whySubscribe.point2": "ale aby lepiej komunikować się z tymi, którzy się liczą.",
  "help.whySubscribe.point3": "Jeśli potrzebujesz:",
  "help.whySubscribe.point4": "przejrzystość między językami",
  "help.whySubscribe.point5": "prawdziwą prywatność",
  "help.whySubscribe.point6": "kontrola kontaktu",
  "help.whySubscribe.point7": "eksport konwersacji",
  "help.whySubscribe.point8": "profesjonalne i pozbawione hałasu doświadczenie",
  "help.whySubscribe.point9": "ArChat® jest do tego przeznaczony.",
  "help.how.step1.description": "Aby uzyskać dostęp, użyj swojego pseudonimu i hasła. Jeżeli nie posiadasz konta, zostanie ono utworzone automatycznie.",
  "help.how.step2.title": "Zaproś swój kontakt",
  "help.how.step2.description": "Zaproś e-mailem ze swojego profilu i określ język oraz tryb rozmowy.",
  "help.how.step3.title": "Napisz w swoim języku",
  "help.how.step3.description": "Napisz w preferowanym języku, a ArChat® automatycznie przetłumaczy wiadomość.",
  "help.how.step4.title": "Odbiorca otrzymuje go przetłumaczony",
  "help.how.step4.description": "Druga osoba otrzymuje wiadomość przetłumaczoną na jej język, z kontekstem i przejrzystością.",
  "help.features.title": "Główne cechy",
  "help.features.translation": "🌐 Automatyczne i natychmiastowe tłumaczenie między językami",
  "help.features.status": "💬 Stany obecności (online, bezczynność, nie przeszkadzać itp.)",
  "help.features.statusCustom": "💬 Niestandardowe statusy z emoji i spersonalizowaną wiadomością",
  "help.features.contacts": "👥 Pełna lista kontaktów z przypiętymi ulubionymi (na górze) i blokami, którymi można zarządzać z poziomu modułu Użytkownicy",
  "help.features.contactsMobile": "📱 Zoptymalizowany widok mobilny ze statusem i wyglądem na górnym pasku (tak samo jak na PC)",
  "help.features.contactsFilter": "👁️ Przycisk Pokaż/ukryj nieulubione kontakty - zmniejsz listę tylko do ulubionych",
  "help.features.contactAlias": "✏️ Niestandardowy alias i prywatne notatki dla każdego kontaktu - kliknij nazwę kontaktu w rozmowie",
  "help.features.themes": "🎨 Dostępne dwa motywy: Argentyna (jasnoniebieski/biały/złoty) i Oscuro (głęboki fiolet)",
  "help.features.messages": "📨 Wiadomości w czasie rzeczywistym ze wskaźnikami czytania, wbudowanymi emoji OpenMoji i widocznym pisaniem",
  "help.features.attachments": "📎 Dołącz pliki zgodne z komunikacją pisemną: zdjęcia, filmy i dokumenty PDF",
  "help.features.camera": "📸 Rób zdjęcia kamerą przednią, tylną lub internetową",
  "help.features.gallery": "🖼️ Wybór pliku z galerii",
  "help.features.compression": "🗜️ Automatyczna kompresja obrazu i generowanie miniatur",
  "help.features.progress": "📊 Pasek postępu podczas przesyłania pliku",
  "help.features.delete": "🗑️Usunięcie własnych wiadomości",
  "help.features.scroll": "⬇️ Automatyczne przewijanie do ostatniej wiadomości podczas otwierania rozmowy",
  "help.features.profile": "👤 Konfigurowalny profil z awatarem, biografią i preferencjami",
  "help.features.profileEdit": "✏️ Bezproblemowa edycja profilu (nie odświeża się podczas edycji)",
  "help.features.countries": "🌍 Pełna lista ponad 195 krajów z automatycznym wyborem strefy czasowej",
  "help.features.registration": "📧 Rejestracja z obowiązkowym Regulaminem przed utworzeniem konta i potwierdzeniem e-mailem",
  "help.features.multilanguage": "🗣️ Wsparcie dla {count} języków z flagami; Regulamin i e-maile przetłumaczone na wybrany język",
  "help.features.pwa": "📲Aplikacja PWA do zainstalowania na urządzeniach mobilnych i stacjonarnych",
  "help.features.sync": "🔄 Automatyczna synchronizacja wiadomości co 5 sekund",
  "help.features.deleteSync": "🗑️ Automatyczna synchronizacja usuniętych wiadomości między urządzeniami",
  "help.features.notifications": "🔔 Powiadomienia dźwiękowe o nowych otrzymanych wiadomościach",
  "help.features.retranslation": "🔄 Automatyczne ponowne tłumaczenie wiadomości, jeśli nie powiedzie się za pierwszym razem",
  "help.features.preview": "👁️ Podgląd plików przed wysłaniem",
  "help.features.security": "🔒 System bezpieczeństwa z CAPTCHA, odciskiem palca, ograniczeniem szybkości i obowiązkowym przepływem T&C",
  "help.features.passwordRecovery": "🔑 Odzyskiwanie hasła przez e-mail",
  "help.features.emailConfirmation": "📧 Potwierdzenie konta e-mailem z linkiem aktywacyjnym",
  "help.features.invitations": "📧 Prywatne zaproszenia e-mailowe — zapraszaj kontakty zewnętrzne z określonym językiem i kontekstem",
  "help.features.invitationsManagement": "📋 Pełne zarządzanie zaproszeniami - wyświetlaj, wysyłaj ponownie lub anuluj oczekujące zaproszenia z menu",
  "help.features.contactStatus": "🏷️ Widoczne statusy kontaktów - zobacz status każdego kontaktu (oczekujący, zarejestrowany, gotowy do czatu)",
  "help.features.favorites": "⭐ System ulubionych – oznaczaj kontakty jako ulubione, aby mieć do nich szybki dostęp",
  "help.features.profilePhoto": "📸 Ulepszone przesyłanie zdjęć profilowych – wybierz zdjęcia z galerii z natychmiastowym podglądem",
  "help.features.translationSender": "👁️ Zobacz tłumaczenia dla nadawcy - Zobacz, jak Twoja wiadomość została przetłumaczona na język odbiorcy",
  "help.features.unifiedContacts": "🔗 Ujednolicony model kontaktu - Kontakty powstają na podstawie istniejących zaproszeń i rozmów",
  "help.features.privacy": "🔒 Domyślnie tryb prywatny - Twój profil jest prywatny i dostępny tylko po bezpośrednim zaproszeniu",
  "help.features.export": "💾 Eksport konwersacji - Eksportuj całe rozmowy do formatu PDF lub HTML wraz z obrazami i plikami",
  "help.tips.title": "Pomocne wskazówki",
  "help.tips.language": "✅ Ustaw swój język za pomocą selektora flag {count}; Regulamin i e-maile są wyświetlane w tym języku",
  "help.tips.status": "✅ Zaktualizuj swój status obecności, aby inni wiedzieli o Twojej dostępności",
  "help.tips.statusCustom": "✅ Twórz niestandardowe statusy za pomocą emoji i wiadomości, aby wyrazić swój aktualny status",
  "help.tips.search": "✅ Zaznacz ulubione (gwiazdka) i zablokuj użytkownikom dostęp do modalu „Użytkownicy”.",
  "help.tips.contactsFilter": "✅ Użyj przycisku oka (👁️) na górnym pasku, aby pokazać lub ukryć nieulubione kontakty",
  "help.tips.contactAlias": "✅ Kliknij nazwę kontaktu w rozmowie, aby dodać niestandardowy alias i prywatne notatki",
  "help.tips.avatar": "✅ Kliknij awatar kontaktu, aby zobaczyć jego zdjęcie w powiększeniu",
  "help.tips.messages": "✅ Ikona ArChat® miga, gdy masz nieprzeczytane wiadomości; wstawiaj emoji za pomocą programu uruchamiającego OpenMoji",
  "help.tips.attachments": "✅ Dołącz obrazy, filmy lub pliki PDF za pomocą przycisku klipu (📎); kompatybilny z komunikacją pisemną",
  "help.tips.camera": "✅ Użyj aparatu, aby robić zdjęcia bezpośrednio z aplikacji",
  "help.tips.compression": "✅ Obrazy są automatycznie kompresowane, aby zaoszczędzić miejsce",
  "help.tips.delete": "✅ Możesz usunąć własne wiadomości, klikając przycisk usuwania",
  "help.tips.profile": "✅ Edytuj swój profil bez napojów gazowanych i przełączaj się między Argentyną / Ciemnością (jasny lub ciemny motyw).",
  "help.tips.themes": "✅ Zmień motyw w Ustawieniach > Wygląd: Argentyna (jasnoniebieski) lub Ciemny (głęboki fiolet)",
  "help.tips.country": "✅ Wybierz w profilu swój kraj, aby strefa czasowa została ustawiona automatycznie",
  "help.message_time_context.title": "Temporalny kontekst wiadomości",
  "help.message_time_context.description": "W każdej wiadomości można zapisać czas lokalny, strefę czasową i kraj nadawcy w momencie wysłania. W ten sposób możesz zobaczyć, dokąd i o której godzinie wysłał inny użytkownik.",
  "help.message_time_context.point1": "W planie FREE pokazywany jest tylko czas w Twojej strefie czasowej (odbiorniku).",
  "help.message_time_context.point2": "W planie PRO pokazywany jest także czas lokalny, kraj i strefa czasowa emitenta.",
  "help.message_time_context.point3": "Kontekst jest zapisywany historycznie w każdej wiadomości.",
  "help.message_time_context.point4": "Zaawansowane funkcje audytu są dostępne w wyższych planach.",
  "help.tips.registration": "✅ Przed rejestracją zaakceptuj Regulamin w swoim języku; następnie zweryfikuj swój adres e-mail, aby aktywować konto",
  "help.tips.writing": "✅ Pisz jasne komunikaty: ArChat® tłumaczy znaczenie tekstu pisanego, zachowując kontekst i przejrzystość",
  "help.tips.install": "✅ Zainstaluj ArChat® jako aplikację PWA na swoim urządzeniu, aby uzyskać szybki dostęp do pulpitu",
  "help.tips.sync": "✅ Wiadomości synchronizują się automatycznie co 5 sekund - nie ma potrzeby odświeżania",
  "help.tips.deleteSync": "✅ Jeśli usuniesz wiadomość, zostanie ona automatycznie usunięta na wszystkich urządzeniach odbiorcy",
  "help.tips.notifications": "✅ Gdy otrzymasz nową wiadomość od innego użytkownika, usłyszysz dźwięk",
  "help.tips.retranslation": "✅ Jeżeli wiadomość nie została poprawnie przetłumaczona, system automatycznie spróbuje ją ponownie przetłumaczyć",
  "help.tips.preview": "✅ Przed wysłaniem sprawdź podgląd pliku, aby upewnić się, że jest on prawidłowy",
  "help.tips.passwordRecovery": "✅ Jeśli zapomniałeś hasła, skorzystaj z linku „Zapomniałeś hasła?” w loginie",
  "help.tips.emailConfirmation": "✅ Po rejestracji sprawdź swoją skrzynkę e-mail i kliknij link potwierdzający",
  "help.tips.languageChange": "✅ Zmień język za pomocą selektora flag: Regulamin, e-maile i interfejs użytkownika są natychmiast aktualizowane",
  "help.tips.inputFixed": "✅ Na komputerze pasek do pisania jest zamocowany na dole ekranu, aby zapewnić większy komfort",
  "help.tips.invitations": "✅ Zaproś kontakty e-mailem ze swojego profilu - od początku zdefiniuj język i tryb rozmowy",
  "help.tips.invitationsManagement": "✅ Zarządzaj zaproszeniami w menu „Wysłane zaproszenia” — wysyłaj ponownie e-maile lub anuluj oczekujące zaproszenia",
  "help.tips.contactStatus": "✅ Zobacz status każdego kontaktu na liście - Oczekująca (pomarańczowa), Zarejestrowana (zielona) lub Aktywna rozmowa (niebieski)",
  "help.tips.favorites": "✅ Oznacz kontakty jako ulubione za pomocą gwiazdki ⭐ - Ulubione pojawiają się jako pierwsze na Twojej liście",
  "help.tips.profilePhoto": "✅ Prześlij swoje zdjęcie profilowe z „Wybierz z galerii” – przed zapisaniem zobaczysz podgląd",
  "help.tips.translationSender": "✅ Wysyłając wiadomość rozwiń panel tłumaczeń, aby zobaczyć jak została ona przetłumaczona na język odbiorcy",
  "help.tips.unifiedContacts": "✅ Twoje kontakty są automatycznie wyświetlane, gdy przyjmują zaproszenia lub prowadzą z nimi rozmowy",
  "help.tips.privacy": "✅ Twój profil jest domyślnie prywatny - Włącz widoczność publiczną w Profil > Prywatność, jeśli chcesz, aby inni Cię znaleźli",
  "help.tips.export": "✅ Eksportuj całe rozmowy za pomocą przycisku ⬇️ w nagłówku — wybierz plik PDF lub HTML ze wszystkimi obrazami",
  "help.support.title": "Średni",
  "help.support.description": "Jeśli masz problemy lub pytania, skontaktuj się z administratorem systemu lub przejrzyj dostępną dokumentację techniczną.",
  "help.about.title": "O",
  "help.about.developer": "Opracowany przez:",
  "help.about.location": "MDQ – ARGENTYNA",
  "help.about.linkedin": "Zobacz profil na LinkedIn",
  "presence.custom.suggestion.coffee": "Mam kilku przyjaciół ☕",
  "presence.custom.suggestion.soccer": "Na korcie ⚽",
  "presence.custom.suggestion.working": "Pracuję jak szalony 💪",
  "presence.custom.suggestion.lunch": "Jem lunch 🍽️",
  "presence.custom.suggestion.family": "Rodzinny obiad 👨‍👩‍👧‍👦",
  "presence.custom.suggestion.studying": "Studiuję 📚",
  "presence.custom.suggestion.travel": "Na wycieczce ✈️",
  "presence.custom.suggestion.meeting": "Na spotkaniu 💼",
  "presence.custom.suggestion.resting": "Odpoczynek 😴",
  "presence.custom.suggestion.gaming": "Gram w gry wideo 🎮",
  "presence.custom.suggestion.reading": "Czytanie 📖",
  "presence.custom.suggestion.offlineSoon": "Zaraz wracam ⏳",
  "export.title": "Eksportuj rozmowę",
  "export.description": "Wybierz format, w jakim chcesz wyeksportować tę rozmowę:",
  "export.progress": "Eksportowanie...",
  "export.format.pdf": "PDF",
  "export.format.pdf.description": "Dokument PDF ze wszystkimi obrazami i plikami",
  "export.format.html": "HTML",
  "export.format.html.description": "Plik HTML, który można otworzyć w dowolnej przeglądarce",
  "export.info": "Eksport obejmie wszystkie wiadomości, obrazy i pliki z tej rozmowy.",
  "export.pro_required.title": "Eksportuj rozmowę",
  "export.pro_required.message": "Ta funkcja jest dostępna w planie PRO.",
  "invitation.modal.title": "Wyślij zaproszenie",
  "invitation.modal.description": "Zaproś kogoś do rozmowy na ArChat®. Na Twój adres e-mail zostanie wysłana wiadomość zawierająca link umożliwiający przyjęcie zaproszenia.",
  "invitation.email.label": "E-mail gościa",
  "invitation.email.placeholder": "ejemplo@email.com",
  "invitation.email.required": "E-mail jest obowiązkowy",
  "invitation.email.invalid": "Proszę podać prawidłowy adres e-mail",
  "invitation.language.label": "Preferowany język gościa",
  "invitation.language.help": "Wiadomość e-mail zostanie wysłana w tym języku",
  "invitation.mode.label": "Tryb rozmowy",
  "invitation.mode.profesional": "Profesjonalny",
  "invitation.mode.profesional.description": "Rozmowa formalna i profesjonalna",
  "invitation.mode.tecnico": "Techniczny",
  "invitation.mode.tecnico.description": "Rozmowy techniczne i specjalistyczne",
  "invitation.mode.casual": "Zwykły",
  "invitation.mode.casual.description": "Nieformalna i przyjazna rozmowa",
  "invitation.message.label": "Wiadomość osobista (opcjonalnie)",
  "invitation.message.placeholder": "Napisz osobistą wiadomość dla gościa...",
  "invitation.send": "Wyślij zaproszenie",
  "invitation.sending": "Przesyłka...",
  "invitation.success": "Zaproszenie zostało wysłane pomyślnie",
  "invitation.success.title": "Zaproszenie wysłane",
  "invitation.success.message": "Zaproszenie zostało wysłane pomyślnie.\\n\\nKontakt otrzyma wiadomość e-mail z linkiem umożliwiającym zaakceptowanie zaproszenia. Po zaakceptowaniu możesz rozpocząć z nim rozmowę.",
  "invitation.error": "Błąd podczas wysyłania zaproszenia",
  "invitation.error.self": "Nie możesz siebie zaprosić",
  "invitation.error.duplicate": "Istnieje już oczekujące zaproszenie dla tego e-maila",
  'invitation.top.title': 'Najlepsi budowniczowie sieci',
  'invitation.top.invitesSuffix': 'zaproszenia',
  "invitation.safe.phase_notice": "Aktywna, bezpieczna faza: korzyści do czasu komercyjnej aktywacji (brak rzeczywistego wpływu na limity).",
  "invitation.safe.generate_code": "Wygeneruj link/kod",
  "invitation.safe.refresh_top3": "Aktualizacja najlepszych 3",
  "invitation.safe.top_loading": "Ładowanie najczęściej zapraszanych osób...",
  "invitation.safe.top_empty": "Nie ma jeszcze polecanych zaproszonych osób.",
  "invitation.safe.hide_full_ranking": "Ukryj pełny ranking",
  "invitation.safe.view_full_ranking": "Zobacz pełny ranking",
  "invitation.safe.hide_metrics_dashboard": "Ukryj panel metryk",
  "invitation.safe.view_metrics_dashboard": "Wyświetl pulpit nawigacyjny metryk",
  "invitation.safe.prepared_link": "Link przygotowany",
  "invitation.safe.email_placeholder": "email@dominio.com",
  "invitation.safe.register_pending": "Zarejestruj się w oczekiwaniu na zaproszenie",
  "invitation.safe.status_summary": "Podsumowanie stanu",
  "invitation.safe.summary.pending": "Kolczyki",
  "invitation.safe.summary.registered": "Zarejestrowany",
  "invitation.safe.summary.active": "Aktywny",
  "invitation.safe.summary.validated": "Zatwierdzone",
  "invitation.safe.summary.rejected": "Odrzucony",
  "invitation.safe.sent_invitations": "Zaproszenia wydane",
  "invitation.safe.table.id": "ID",
  "invitation.safe.table.invited_email": "E-mail gościa",
  "invitation.safe.table.code": "Kod",
  "invitation.safe.table.status": "Państwo",
  "invitation.safe.table.created": "Stworzony",
  "invitation.safe.empty_sent": "Nie wydano jeszcze żadnych zaproszeń.",
  "invitation.safe.simulated_rewards": "Zdobyte symulowane nagrody",
  "invitation.safe.empty_rewards": "Na razie brak symulowanych nagród.",
  "invitation.safe.error.load_status": "Nie udało się wczytać stanu zaproszenia.",
  "invitation.safe.error.generate_code": "Nie udało się wygenerować kodu.",
  "invitation.safe.error.invalid_email": "Wpisz prawidłowy adres e-mail, aby zarejestrować zaproszenie.",
  "invitation.safe.error.register_pending": "Nie można zarejestrować oczekującego zaproszenia.",
  "invitation.safe.success.code_generated": "Pomyślnie wygenerowano kod.",
  "invitation.safe.success.pending_registered": "Oczekujące zaproszenie zarejestrowane w trybie awaryjnym.",
  "invitation.ranking.position": "Pozycja",
  "invitation.ranking.user": "Użytkownik",
  "invitation.ranking.validatedInvites": "Sprawdzone zaproszenia",
  "invitation.ranking.empty": "Brak zatwierdzonych zaproszeń do wyświetlenia.",
  "invitation.ranking.loading": "Ładowanie rankingu...",
  "invitation.ranking.loadError": "Nie udało się wczytać rankingu.",
  "invitation.list.empty": "Nie wysłałeś żadnego zaproszenia",
  "invitation.list.email": "E-mail",
  "invitation.list.language": "Język",
  "invitation.list.mode": "Tryb",
  "invitation.list.status": "Państwo",
  "invitation.list.created": "Wysłano",
  "invitation.list.expires": "Wygasa",
  "invitation.list.actions": "Działania",
  "invitation.status.pending": "Kolczyk",
  "invitation.status.accepted": "Przyjęty",
  "invitation.status.expired": "Wygasły",
  "invitation.status.cancelled": "Odwołany",
  "invitation.status.deleted": "Wyłączony",
  "invitation.deleted.tooltip": "To zaproszenie zostało usunięte",
  "invitation.status.rejected": "Odrzucony",
  "invitation.status.bounced": "Odbił się",
  "invitation.status.unknown": "Nieznany stan",
  "invitation.copy.link": "Skopiuj link",
  "invitation.copy.success": "Link skopiowany do schowka",
  "invitation.cancel": "Anulować",
  "invitation.cancel.confirm": "Czy na pewno anulować to zaproszenie?",
  "invitation.cancel.success": "Zaproszenie zostało pomyślnie anulowane",
  "invitation.cancel.title": "Potwierdź anulowanie",
  "invitation.resend": "Przekaż e-mail",
  "invitation.resend.title": "Wyślij ponownie zaproszenie",
  "invitation.resend.success": "E-mail z zaproszeniem został pomyślnie przekazany",
  "invitation.resend.error": "Błąd podczas ponownego wysyłania e-maila z zaproszeniem",
  "invitation.accept.title": "Zaakceptuj zaproszenie",
  "invitation.accept.description": "Zostałeś zaproszony do czatu na ArChat®",
  "invitation.accept.inviter": "Zaproszony przez",
  "invitation.accept.message": "osobista wiadomość",
  "invitation.accept.login": "Login",
  "invitation.accept.register": "Rejestr",
  "invitation.accept.error.invalid": "Nieprawidłowy token zaproszenia",
  "invitation.accept.error.expired": "To zaproszenie wygasło",
  "invitation.accept.error.accepted": "To zaproszenie zostało już zaakceptowane",
  "invitation.accept.error.cancelled": "To zaproszenie zostało anulowane",
  "invitation.accept.error.email_mismatch": "Adres e-mail Twojego konta nie jest zgodny z adresem e-mail z zaproszeniem",
  "invitation.accept.success": "Zaproszenie przyjęte. Przekierowywanie do czatu...",
  "invitations.sent.empty": "Brak oczekujących zaproszeń",
  "invitations.columns.email": "E-mail",
  "invitations.columns.language": "Język",
  "invitations.columns.mode": "Tryb",
  "invitations.columns.status": "Państwo",
  "invitations.columns.sentAt": "Wysłano",
  "invitations.columns.actions": "Działania",
  "invitations.status.pending": "Kolczyk",
  "invitations.status.accepted": "Przyjęty",
  "invitations.status.cancelled": "Odwołany",
  "invitations.status.expired": "Wygasły",
  "invitations.actions.cancel": "Anulować",
  "invitations.actions.copy": "Skopiuj link",
  "invitations.actions.resend": "Przekaż e-mail",
  "invitations.waitBeforeResend": "Nie możesz jeszcze wysłać zaproszenia ponownie. Musisz odczekać 10 minut pomiędzy każdym wysłaniem, aby uniknąć spamowania użytkownika-gościa.",
  "invitations.captchaQuestion": "Ile wynosi %1 + %2?",
  "invitations.resendSuccess": "Zaproszenie zostało pomyślnie przekazane.",
  "invitations.dailyLimit": "Osiągnąłeś dzisiaj maksymalną dozwoloną liczbę ponownych zgłoszeń.",
  "invitations.invalidEmail": "Serwer pocztowy zgłosił, że ten adres jest nieprawidłowy.",
  "profile.privacy.title": "Prywatność",
  "profile.privacy.public_visibility": "Ustaw mój profil jako publiczny",
  "profile.privacy.public_warning": "Dzięki temu każdy użytkownik ArChat® może Cię znaleźć i rozpocząć rozmowę.",
  "profile.privacy.private_info": "Twój profil jest prywatny. Tylko użytkownicy, których zaprosisz lub którzy Cię zaproszą, będą mogli z Tobą czatować.",
  "profile.privacy.private_default": "Domyślnie Twój profil jest prywatny, co zapewnia większe bezpieczeństwo.",
  "common.save": "Trzymać",
  "common.saving": "Oszczędność...",
  'buttons.accept': 'Akceptuj',
  "buttons.cancel": "Anulować",
  "buttons.save": "Trzymać",
  "buttons.edit": "Redagować",
  "buttons.retry": "Spróbować ponownie",
  "buttons.confirm": "Potwierdzać",
  "buttons.yes": "Tak",
  "buttons.no": "NIE",
  "buttons.send": "Wysłać",
  "buttons.continue": "Kontynuować",
  "buttons.delete": "Wyeliminować",
  "buttons.logout": "Wychodzić",
  "buttons.back": "Powrót",
  "buttons.update": "Aktualizacja",
  "buttons.upload": "Zwiększyć",
  "buttons.select": "Wybierać",
  "achievement.unlocked": "Osiągnięcie odblokowane",
  "achievement.continue": "Kontynuować",
  "contact.edit.info.personalized": "Zmiany te są personalizowane specjalnie dla Ciebie i nie mają wpływu na innych użytkowników.",
  "contact.edit.profileInfo": "Informacje o profilu",
  "dashboard.loading": "Ładowanie danych...",
  "dashboard.error.title": "Błąd",
  "dashboard.error.load": "Nie udało się załadować danych o użytkowaniu",
  "dashboard.error.generic": "Błąd podczas ładowania panelu",
  "dashboard.error.no_data": "Nie można załadować danych",
  "dashboard.retry": "Spróbować ponownie",
  "dashboard.unlimited": "Nieograniczony",
  'dashboard.not_available': 'Niedostępne',
  "dashboard.plan.free": "FREE",
  "dashboard.plan.pro": "PRO",
  "dashboard.plan.enterprise": "ENTERPRISE",
  "dashboard.card.chars": "Pismo",
  "dashboard.card.chars_month": "Postacie w tym miesiącu",
  "dashboard.card.storage": "Składowanie",
  "dashboard.card.devices": "Aktywne urządzenia",
  "dashboard.admin.title": "Wskaźniki wzrostu",
  "dashboard.admin.newUsersToday": "Nowi użytkownicy dzisiaj",
  "dashboard.admin.messagesSentToday": "Wiadomości wysłane dzisiaj",
  "dashboard.admin.translationsUsed": "Wykorzystane tłumaczenia",
  "dashboard.admin.invitesCreated": "Zaproszenia utworzone",
  "dashboard.admin.invitesValidated": "Sprawdzone zaproszenia",
  "dashboard.admin.inviteConversion": "Konwersja zaproszeń",
  "dashboard.admin.kFactor": "Współczynnik K",
  "dashboard.admin.newUsers": "Nowi użytkownicy",
  "dashboard.admin.messagesSent": "Wysłane wiadomości",
  "dashboard.admin.noData": "Brak danych",
  "dashboard.admin.kFactor.viral": "Wirusowy",
  "dashboard.admin.kFactor.stable": "Stabilny",
  "dashboard.admin.kFactor.low": "Niski",
  "dashboard.admin.emailMetrics": "Dane e-mailowe",
  "dashboard.admin.email.sent": "Wysłano",
  "dashboard.admin.email.delivered": "Dostarczony",
  "dashboard.admin.email.opened": "Otwarte",
  "dashboard.admin.email.clicked": "Kliknięcia",
  "dashboard.admin.email.bounced": "Odbił się",
  "dashboard.admin.email.deliveryRate": "Szybkość dostawy",
  "dashboard.admin.email.openRate": "Kurs otwarcia",
  "dashboard.admin.email.bounceRate": "współczynnik odrzuceń",
  "dashboard.admin.funnelMetrics": "Metryki ścieżki",
  "dashboard.admin.funnel.registered": "Zarejestrowany",
  "dashboard.admin.funnel.confirmed": "Potwierdzony",
  "dashboard.admin.funnel.loggedIn": "Pierwsze logowanie",
  "dashboard.admin.funnel.firstMessage": "Pierwsza wiadomość",
  "dashboard.admin.funnel.abandoned": "Opuszczony",
  "dashboard.admin.funnel.conversionRate": "Współczynnik konwersji",
  "dashboard.admin.funnel.activationRate": "Współczynnik aktywacji",
  "dashboard.admin.funnel.dropoffRate": "Wskaźnik rezygnacji",
  "dashboard.admin.loading": "Ładowanie danych...",
  "dashboard.admin.errorLoad": "Nie można załadować panelu metryk.",
  "dashboard.admin.growthViral": "Wzrost wirusa",
  "dashboard.admin.growthStable": "Stabilny wzrost",
  "dashboard.admin.growthLow": "Niski wzrost",
  "dashboard.upgrade.title": "Czy potrzebujesz więcej zasobów?",
  'dashboard.upgrade.message': 'Upgrade your plan to get more contacts, characters, storage and active devices.',
  "dashboard.upgrade.button": "Ulepsz plan",
  "upgrade.title": "Ulepsz plan",
  "upgrade.close": "Zamknąć",
  "upgrade.cancel": "Anulować",
  "upgrade.activate": "Aktywuj plan PRO",
  "upgrade.activating": "Aktywuję...",
  'upgrade.price.amount': '',
  'upgrade.price.period': '',
  'upgrade.price.note': '',
  "upgrade.comparison.title": "Porównanie planów",
  "upgrade.free.label": "Bezpłatny plan",
  "upgrade.free.limits.contacts": "Maksymalnie 2 kontakty",
  "upgrade.free.limits.conversations": "Maksymalnie 2 rozmowy",
  "upgrade.free.limits.no_export": "Brak eksportu danych",
  "upgrade.free.limits.no_advanced": "Brak zaawansowanych funkcji",
  "upgrade.pro.label": "Plan profesjonalny",
  "upgrade.pro.recommended": "ZALECONY",
  'upgrade.pro.benefits.contacts': 'Unlimited contacts',
  'upgrade.pro.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.pro.benefits.conversations': 'Unlimited conversations',
  'upgrade.pro.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.pro.benefits.export": "Eksport rozmów",
  "upgrade.pro.benefits.export.desc": "Eksportuj swoje rozmowy w wielu formatach (PDF, TXT, JSON)",
  "upgrade.pro.benefits.notifications": "Zaawansowane powiadomienia",
  "upgrade.pro.benefits.notifications.desc": "Niestandardowe powiadomienia i ustawienia zaawansowane",
  'upgrade.pro.benefits.translation': 'Unlimited automatic translation',
  'upgrade.pro.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.pro.benefits.files': 'Unlimited file sharing',
  'upgrade.pro.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.pro.benefits.themes": "Niestandardowe motywy",
  "upgrade.pro.benefits.themes.desc": "Dostęp do wszystkich motywów i zaawansowane dostosowywanie",
  "upgrade.pro.benefits.security": "Zaawansowane zabezpieczenia",
  "upgrade.pro.benefits.security.desc": "Dodatkowa ochrona i ulepszone funkcje prywatności",
  "upgrade.pro.benefits.analytics": "Statystyki i analizy",
  "upgrade.pro.benefits.analytics.desc": "Uzyskaj dostęp do szczegółowych statystyk swojej aktywności",
  "upgrade.pro.benefits.priority": "Wsparcie priorytetowe",
  "upgrade.pro.benefits.priority.desc": "Priorytetowa uwaga i szybka reakcja na Twoje zapytania",
  "upgrade.enterprise.label": "Plan korporacyjny",
  "upgrade.enterprise.title": "ENTERPRISE",
  "upgrade.enterprise.benefits.contacts": "Nielimitowane kontakty",
  "upgrade.enterprise.benefits.support": "Priorytetowe wsparcie 24/7",
  "upgrade.enterprise.benefits.custom": "Niestandardowe rozwiązania",
  "upgrade.enterprise.benefits.advanced": "Zaawansowane funkcje biznesowe",
  "upgrade.enterprise.benefits.integration": "Niestandardowe integracje",
  "upgrade.enterprise.benefits.dedicated": "Dedykowane wsparcie",
  "upgrade.success.title": "Aktywowano plan PRO",
  "upgrade.success.message": "Twój plan został uaktualniony do wersji PRO. Ciesz się wszystkimi nieograniczonymi funkcjami.",
  "upgrade.error.title": "Błąd podczas aktywacji PRO",
  "upgrade.error.message": "Nie udało się zaktualizować planu. Spróbuj ponownie.",
  "upgrade.error.generic": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie.",
  'upgrade.benefits.contacts': 'Unlimited contacts',
  'upgrade.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.benefits.conversations': 'Unlimited conversations',
  'upgrade.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.benefits.export": "Eksport rozmów",
  "upgrade.benefits.export.desc": "Eksportuj swoje rozmowy w wielu formatach (PDF, TXT, JSON)",
  "upgrade.benefits.notifications": "Zaawansowane powiadomienia",
  "upgrade.benefits.notifications.desc": "Niestandardowe powiadomienia i ustawienia zaawansowane",
  'upgrade.benefits.translation': 'Unlimited automatic translation',
  'upgrade.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.benefits.files': 'Unlimited file sharing',
  'upgrade.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.benefits.themes": "Niestandardowe motywy",
  "upgrade.benefits.themes.desc": "Dostęp do wszystkich motywów i zaawansowane dostosowywanie",
  "upgrade.benefits.security": "Zaawansowane zabezpieczenia",
  "upgrade.benefits.security.desc": "Dodatkowa ochrona i ulepszone funkcje prywatności",
  "upgrade.benefits.analytics": "Statystyki i analizy",
  "upgrade.benefits.analytics.desc": "Uzyskaj dostęp do szczegółowych statystyk swojej aktywności",
  "upgrade.benefits.priority": "Wsparcie priorytetowe",
  "upgrade.benefits.priority.desc": "Priorytetowa uwaga i szybka reakcja na Twoje zapytania",
  "upgrade.limits.contacts": "Maksymalnie 2 kontakty",
  "upgrade.limits.conversations": "Maksymalnie 2 rozmowy",
  "upgrade.limits.no_export": "Brak eksportu danych",
  "upgrade.limits.no_advanced": "Brak zaawansowanych funkcji",
  "api.error.image_processing_not_available": "Przetwarzanie obrazu nie jest dostępne na serwerze",
  "api.error.image_functions_not_available": "Funkcje przetwarzania obrazu są niedostępne",
  "api.error.method_not_allowed": "Niedozwolona metoda",
  "api.error.user_not_identified": "Niezidentyfikowany użytkownik",
  "api.error.upload_file_too_large_php": "Plik przekracza maksymalny rozmiar dozwolony przez PHP",
  "api.error.upload_file_too_large_form": "Plik przekracza maksymalny rozmiar dozwolony w formularzu",
  "api.error.upload_file_partial": "Plik został częściowo przesłany",
  "api.error.upload_no_file": "Nie przesłano pliku",
  "api.error.upload_no_temp_dir": "Brak katalogu tymczasowego",
  "api.error.upload_cant_write": "Błąd zapisu pliku na dysk",
  "api.error.upload_extension_stopped": "Rozszerzenie PHP przestało przesyłać",
  "api.error.upload_generic": "Błąd przesyłania pliku",
  "api.error.file_type_not_allowed": "Typ pliku nie jest dozwolony. Dozwolone są tylko obrazy (JPEG, PNG, GIF, WEBP).",
  "api.error.file_too_large": "Plik jest za duży (maks. 10MB)",
  "api.error.storage_limit_exceeded": "Przekroczono limit miejsca. Uaktualnij swój plan, aby przesyłać więcej plików.",
  "api.error.user_not_found": "Nie znaleziono użytkownika lub jest on nieaktywny",
  "api.error.image_directory_access": "Błąd dostępu do katalogu obrazów",
  "api.error.file_extension_not_allowed": "Rozszerzanie pliku jest niedozwolone",
  "api.error.temp_file_save": "Błąd podczas zapisywania pliku tymczasowego",
  "api.error.image_processing": "Błąd podczas przetwarzania obrazu",
  "api.error.database_update": "Błąd podczas aktualizacji bazy danych",
  "api.error.internal_server_error": "Wewnętrzny błąd serwera",
  "api.error.internal_server_error_debug": "Wewnętrzny błąd serwera",
  "api.error.user_id_required": "Wymagany identyfikator użytkownika",
  "api.error.profile_not_found": "Nie znaleziono profilu",
  "api.error.profile_load_failed": "Błąd ładowania profilu",
  "api.error.invalid_data": "Nieprawidłowe dane",
  "api.error.validation_errors": "Błędy walidacyjne",
  "api.error.profile_update_failed": "Nie można zaktualizować profilu",
  "api.error.profile_update_error": "Błąd aktualizacji profilu",
  "api.success.photo_updated": "Zaktualizowane zdjęcie",
  "api.success.profile_loaded": "Profil został załadowany pomyślnie",
  "api.success.profile_updated": "Profil został pomyślnie zaktualizowany",
  "errors.deviceLimit.title": "Osiągnięto limit urządzeń",
  "errors.deviceLimit.solution": "Aby kontynuować, wyloguj się z innych urządzeń lub uaktualnij swój plan.",
  "errors.network.title": "Błąd połączenia",
  "errors.network.message": "Nie można połączyć się z serwerem. Sprawdź swoje połączenie internetowe.",
  "errors.server.invalidResponse.title": "Błąd serwera",
  "errors.server.invalidResponse.message": "Serwer zwrócił nieprawidłową odpowiedź. Spróbuj ponownie.",
  "errors.modal.title": "Błąd",
  "errors.modal.copyDetails": "Skopiuj szczegół",
  "errors.modal.close": "Zamknąć",
  "errors.modal.reportSupport": "Zgłoś do wsparcia",
  "errors.modal.code": "Kod",
  "errors.modal.message": "Wiadomość",
  "errors.modal.path": "Trasa",
  "errors.modal.time": "Godzina",
  "errors.modal.timestamp": "Znacznik czasu",
  "errors.modal.copied": "Skopiowany szczegół",
  "errors.generic.title": "Błąd",
  "errors.generic.message": "Wystąpił błąd. Spróbuj ponownie.",
  "errors.unexpected": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie.",
  "errors.boundary.title": "REAKTUJ Wychwycony błąd",
  "errors.boundary.request_id": "Identyfikator żądania X:",
  "errors.boundary.correlate": "Mapuj do backend/logs/structured.log",
  "errors.boundary.message_label": "Wiadomość:",
  "errors.boundary.stack_trace": "Ślad stosu",
  "errors.boundary.component_stack": "stos komponentów",
  "errors.boundary.empty": "(pusty)",
  "errors.boundary.reload_page": "Załaduj ponownie stronę",
  "errors.ui_boundary.refresh": "Błąd interfejsu ArChat — przeładuj stronę",
  "bootstrap.error.title": "ArChat® — Błąd uruchamiania",
  "common.reload": "Naładuj",
  "errors.avatarTooLarge": "Rozmiar obrazu przekracza dozwolony rozmiar 2MB.",
  "errors.avatarTooLarge.title": "Obraz jest za duży",
  "errors.avatarTooLarge.message": "Rozmiar obrazu przekracza dozwolony rozmiar 2MB.",
  "errors.invalidImageType": "Wybrany plik nie jest prawidłowym obrazem.",
  "errors.invalidImageType.title": "Nieprawidłowy plik",
  "errors.invalidImageType.message": "Wybrany plik nie jest prawidłowym obrazem.",
  "errors.uploadFailed": "Nie można przesłać obrazu. Spróbuj ponownie.",
  "errors.uploadFailed.title": "Błąd przesyłania",
  "errors.uploadFailed.message": "Nie można przesłać obrazu. Spróbuj ponownie.",
  "errors.conversationCreate": "Błąd podczas tworzenia rozmowy. Spróbuj ponownie.",
  "errors.conversationInvalidId": "Nieprawidłowy identyfikator rozmowy.",
  "errors.conversationOpen": "Błąd podczas otwierania rozmowy. Spróbuj ponownie.",
  "errors.favoriteUpdate": "Nie udało się zaktualizować ulubionego",
  "errors.blockUpdate": "Nie można zaktualizować blokady",
  "errors.messageEdit": "Błąd podczas edytowania wiadomości.",
  "errors.generic.403.title": "Błąd dostępu",
  "errors.generic.403.message": "Nie masz uprawnień do wykonania tej czynności.",
  "errors.saas_max_users": "Osiągnięto limit użytkowników planu ({current}/{limit}).",
  "errors.tenant_frozen": "Najemca jest chwilowo zablokowany.",
  "errors.auth_invalid_credentials": "Nieprawidłowa nazwa użytkownika lub hasło.",
  "errors.foundation_sold_out": "Miejsca założycielskie są wyprzedane.",
  "errors.unexpected_error": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie.",
  "errors.accountInactive.title": "Konto jest nieaktywne. Uzupełnij swój adres e-mail, aby go ponownie aktywować.",
  "errors.userInactive.title": "Dezaktywowane konto",
  "errors.tenantMismatch.title": "Błąd najemcy",
  "errors.accountInactive.activate": "Aktywuj teraz",
  "errors.accountInactive.accept": "Przyjąć",
  "errors.accountInactive.success": "Konto reaktywowane. Możesz się teraz zalogować.",
  "errors.accountInactive.fail": "Nie udało się ponownie aktywować konta. Spróbuj ponownie.",
  "errors.accountInactive.completeSuccess": "Konto aktywowane za pomocą Twojego adresu e-mail. Możesz się teraz zalogować.",
  "errors.accountInactive.completeFail": "Nie można ukończyć aktywacji. Sprawdź e-mail i spróbuj ponownie.",
  "plan.errors.deviceLimit.title": "Osiągnięto limit planu",
  "plan.errors.deviceLimit.message": "Twój obecny plan ma ograniczenie liczby jednocześnie podłączonych urządzeń.",
  "plan.errors.deviceLimit.solution": "Aby kontynuować, wyloguj się z innych urządzeń lub uaktualnij swój plan do wersji PRO.",
  "plan.errors.contactsLimit.title": "Osiągnięto limit kontaktów",
  "plan.errors.contactsLimit.message": "Twój obecny plan ma ograniczenie liczby kontaktów, jakie możesz mieć.",
  "plan.errors.contactsLimit.solution": "Aby dodać więcej kontaktów, uaktualnij swój plan do wersji PRO.",
  "plan.errors.invitationsLimit.title": "Osiągnięto limit zaproszeń",
  "plan.errors.invitationsLimit.message": "Twój obecny plan ma ograniczoną liczbę zaproszeń, które możesz wysłać dziennie.",
  "plan.errors.invitationsLimit.solution": "Aby wysłać więcej zaproszeń, uaktualnij swój plan do wersji PRO.",
  "plan.errors.messagesLimit.title": "Osiągnięto limit wiadomości",
  "plan.errors.messagesLimit.message": "Twój obecny plan ma ograniczoną liczbę wiadomości, które możesz wysłać dziennie.",
  "plan.errors.messagesLimit.solution": "Aby wysyłać więcej wiadomości, uaktualnij swój plan do wersji PRO.",
  "plan.errors.storageLimit.title": "Osiągnięto limit miejsca na dane",
  "plan.errors.storageLimit.message": "Twój obecny plan ma ograniczoną ilość dostępnego miejsca.",
  "plan.errors.storageLimit.solution": "Aby uzyskać więcej miejsca, uaktualnij do wersji PRO.",
  "plan.errors.chatsLimit.title": "Osiągnięto limit rozmów",
  "plan.errors.chatsLimit.message": "Twój obecny plan ma ograniczoną liczbę rozmów, które możesz przeprowadzić.",
  "plan.errors.chatsLimit.solution": "Aby prowadzić więcej rozmów, uaktualnij swój plan do wersji PRO.",
  "plan.errors.upgradeRequired.title": "Wymagana aktualizacja planu",
  "plan.errors.upgradeRequired.message": "Ta funkcja wymaga wyższego planu niż ten, który aktualnie posiadasz.",
  "plan.errors.upgradeRequired.solution": "Aby uzyskać dostęp do tej funkcji, uaktualnij swój plan do wersji PRO.",
  "appearance.theme.system": "System",
  "appearance.theme.corporate": "Zbiorowy",
  "theme.system": "System",
  "theme.corporate": "Zbiorowy",
  "founder.modalClose": "Zamknąć",
  "founder.activeCountLabel": "Aktywni Założyciele",
  "founder.urgency.lastSlots": "Dostępne ostatnie miejsca dla Fundatorów",
  "founder.positionLabel": "Założyciel #{pozycja} / {limit}",
  "founder.leaderboard.title": "Najlepsi założyciele",
  'auth.tagline': 'Siła bycia zrozumianym, niezależnie od języka',
  'auth.sign_in': 'Zaloguj się',
  'auth.create_account': 'Utwórz konto',
  'ui.search_contact': 'Szukaj kontaktu...',
  'ui.language': 'Język',
  "contacts.mode": "Tryb",
  "contacts.sent": "Wysłano",
  "contacts.actions": "Działania",
  "contacts.pending": "Kolczyk",
  "contacts.invited_registered": "Gość - zarejestrowany",
  "table.email": "E-mail",
  "table.language": "Język",
  "table.mode": "Tryb",
  "table.status": "Państwo",
  "table.sent": "Wysłano",
  "table.actions": "Działania",
  "admin.access_denied.message": "Wiadomość",
  "admin.access_denied.title": "Tytuł",
  "admin.action.change_plan": "Zmień plan",
  "admin.action.reactivate": "Reaktywować",
  "admin.action.suspend": "Wstrzymać",
  "admin.action.view": "Pogląd",
  "admin.confirm.change_plan.message": "Wiadomość",
  "admin.confirm.change_plan.title": "Tytuł",
  "admin.confirm.suspend.message": "Wiadomość",
  "admin.confirm.suspend.title": "Tytuł",
  "admin.details.created": "Stworzony",
  "admin.details.current_plan": "Aktualny plan",
  "admin.details.domain": "Domena",
  "admin.details.last_activity": "Ostatnia aktywność",
  "admin.details.name": "Ignam",
  "admin.details.plan": "Plan",
  "admin.details.status": "Status",
  "admin.details.subscription": "Prenumerata",
  "admin.details.tenant_id": "Identyfikator najemcy",
  "admin.details.tenant_info": "Informacje o najemcy",
  "admin.details.usage": "Stosowanie",
  "admin.error.change_plan": "Zmień plan",
  "admin.error.generic": "Ogólny",
  "admin.error.load_details": "Załaduj szczegóły",
  "admin.error.load_tenants": "Załaduj najemców",
  "admin.error.reactivate": "Reaktywować",
  "admin.error.suspend": "Wstrzymać",
  "admin.error.title": "Tytuł",
  "admin.filter.active": "Aktywować",
  "admin.filter.all_plans": "Wszystkie plany",
  "admin.filter.all_status": "Wszystkie stany",
  "admin.filter.suspended": "Wstrzymać",
  "admin.limit.devices": "Urządzenia",
  "admin.limit.invitations": "Zaproszenia",
  "admin.limit.messages": "wiadomości",
  "admin.limit.storage": "Składowanie",
  "admin.limit.users": "Użytkownicy",
  "admin.loading": "Załadunek",
  "admin.no_tenants": "Nie-najemcy",
  "admin.plan.enterprise": "Enterprise",
  "admin.plan.free": "Free",
  "admin.plan.pro": "Pro",
  "admin.status.active": "Aktywować",
  "admin.status.suspended": "Wstrzymać",
  'admin.subscription.id': 'Id',
  "admin.subscription.last_payment": "Ostatnia płatność",
  "admin.subscription.status": "Status",
  "admin.subtitle": "Podtytuł",
  "admin.success.plan_changed": "Plan zmieniony",
  "admin.success.tenant_reactivated": "Najemca został reaktywowany",
  "admin.success.tenant_suspended": "Najemca zawieszony",
  "admin.success.title": "Tytuł",
  "admin.table.actions": "Działania",
  "admin.table.messages": "wiadomości",
  "admin.table.name": "Ignam",
  "admin.table.plan": "Plan",
  "admin.table.status": "Status",
  "admin.table.storage": "Składowanie",
  "admin.table.tenant_id": "Identyfikator najemcy",
  "admin.table.users": "Użytkownicy",
  "admin.title": "Tytuł",
  "admin.usage.devices": "Urządzenia",
  "admin.usage.invitations": "Zaproszenia",
  "admin.usage.messages": "wiadomości",
  "admin.usage.storage": "Składowanie",
  "admin.usage.users": "Użytkownicy",
  "auth.login": "Login",
  "auth.register": "Rejestr",
  "auth.reset_password": "zresetować hasło",
  "billing.cancel.button": "przycisk",
  "billing.cancel.canceling": "Anulowanie",
  "billing.cancel.confirm": "Potwierdzać",
  "billing.cancel.error": "Błąd",
  "billing.cancel.success": "sukces",
  "billing.character_billing.characters_used": "Używane znaki",
  "billing.character_billing.consumption_pct": "Zużycie proc",
  "billing.character_billing.days_remaining": "Pozostało dni",
  "billing.character_billing.deletion_date": "Data usunięcia",
  "billing.character_billing.period_start": "Początek okresu",
  "billing.character_billing.renewal_date": "Data odnowienia",
  "billing.character_billing.title": "Tytuł",
  "billing.current_plan": "Aktualny plan",
  "billing.founder_badge": "Odznaka założyciela",
  "billing.no_plans": "Nie planuj",
  'billing.subscription.canceled': 'Canceled',
  'billing.subscription.canceled_note': 'Canceled note',
  "billing.subscription.next_payment": "Następna płatność",
  "billing.subscription.plan": "Plan",
  'billing.subscription.price': 'Cena planu',
  "billing.subscription.started": "Rozpoczęło się",
  "billing.subscription.status": "Status",
  "billing.subscription.mp_flow.subscribe_failed": "Nie można rozpocząć subskrypcji. Spróbuj ponownie.",
  "billing.subscription.mp_flow.change_plan_failed": "Planu nie można było zmienić. Spróbuj ponownie.",
  "billing.subscription.mp_status.pending": "Kolczyk",
  "billing.subscription.mp_status.authorized": "Upoważniony",
  "billing.subscription.mp_status.active": "Aktywny",
  "billing.subscription.mp_status.paused": "Wstrzymano",
  "billing.subscription.mp_status.cancelled": "Odwołany",
  "billing.subscription.mp_status.inactive": "Nieaktywny",
  "billing.subscription.mp_status.unknown": "Nieznajomy",
  "billing.unlimited": "Nieograniczony",
  "billing.update_plan": "Zaktualizuj plan",
  "billing.update_plan_modal.title": "Tytuł",
  "billing.usage.loading": "Załadunek",
  "common.accept": "Przyjąć",
  "common.confirmPassword": "Potwierdź hasło",
  "common.error": "Błąd",
  "dashboard.upgrade.to_plan": "Planować",
  "emoji.noResults": "Brak wyników",
  "emoji.pick": "Wybierać",
  "export.restricted.message": "Wiadomość",
  "export.restricted.title": "Tytuł",
  "export.restricted.upgrade": "Aktualizacja",
  "founder.*": "*",
  "help.faq.a1": "A1",
  "help.faq.a2": "A2",
  "help.faq.a3": "A3",
  "help.faq.a4": "A4",
  "help.faq.a5": "A5",
  "help.faq.a6": "A6",
  "help.faq.a7": "A7",
  "help.faq.q1": "Pytanie 1",
  "help.faq.q2": "Pytanie 2",
  "help.faq.q3": "Pytanie 3",
  "help.faq.q4": "Pytanie 4",
  "help.faq.q5": "Pytanie 5",
  "help.faq.q6": "Pytanie 6",
  "help.faq.q7": "Pytanie 7",
  "help.faq.title": "Tytuł",
  "help.howWorks.step4.point7": "Punkt 7",
  "help.message_time_context.free_vs_pro": "Darmowy kontra profesjonalny",
  "help.message_time_context.point5": "Punkt 5",
  "help.plans.enterprise.benefits": "Korzyści",
  "help.plans.enterprise.description": "Opis",
  "help.plans.enterprise.title": "Tytuł",
  "help.plans.foundation.devices": "Urządzenia",
  "help.plans.free.description": "Opis",
  "help.plans.free.devices": "Urządzenia",
  "help.plans.free.limits": "Granice",
  "help.plans.free.title": "Tytuł",
  "help.plans.intro": "Wprowadzenie",
  "help.plans.pro.benefits": "Korzyści",
  "help.plans.pro.description": "Opis",
  "help.plans.pro.devices": "Urządzenia",
  'help.plans.pro.price': '$19 / miesiąc',
  "help.plans.pro.title": "Tytuł",
  "help.plans.pro.upgrade": "Aktualizacja",
  "help.plans.title": "Tytuł",
  "help.plans.urgent_slots_badge": "Pilna odznaka slotów",
  "help.slogan.final": "Koniec",
  "help.suggestions.point1": "Punkt 1",
  "help.suggestions.point2": "Punkt 2",
  "help.suggestions.title": "Tytuł",
  "invitation.already_contact_added": "Już dodano kontakt",
  "invitation.already_contact_title": "Już tytuł kontaktu",
  "invitation.already_pending": "Już w toku",
  "invitation.language.invalid": "Nieważny",
  "message.send": "Wysłać",
  "message.sendFile": "Wyślij plik",
  "messages.conversations": "Rozmowy",
  "messages.no_conversations_subtitle": "Brak napisów do rozmów",
  "messages.no_conversations_title": "Brak tytułu rozmowy",
  "presence.custom.edit": "Redagować",
  "profile.enrichment.country": "kraj",
  "profile.enrichment.country.select": "Wybierać",
  "profile.enrichment.description": "Opis",
  "profile.enrichment.org_size": "Rozmiar organizacji",
  "profile.enrichment.org_size.placeholder": "posiadacz miejsca",
  "profile.enrichment.save": "Ratować",
  "profile.enrichment.skip": "pominąć",
  "profile.enrichment.title": "Tytuł",
  "profile.enrichment.usage_type.label": "Etykieta",
  "profile.enrichment.usage_type.placeholder": "posiadacz miejsca",
  "profile.founderPosition": "Stanowisko Założyciela",
  "settings.confirmations.description": "Opis",
  "settings.confirmations.disable": "Wyłączyć",
  "settings.confirmations.title": "Tytuł",
  "settings.confirmations.updated": "Zaktualizowano",
  "settings.title": "Tytuł",
  "theme.description": "Opis",
  "google.unavailable_tenant": "Google jest niedostępny dla tego dzierżawcy.",
  "google.unavailable": "Google niedostępne.",
  "google.verify_client_id": "Zweryfikuj identyfikator klienta w Google Cloud Console.",
  'google.login_aria': 'Zaloguj się przez Google',
  "message.preview_alt": "Zapowiedź",
  "message.image_attachment_alt": "Załączony obraz",
  "profile.avatar.alt": "awatara",
  "plan.name.free": "FREE",
  "plan.name.pro": "PRO",
  "plan.name.foundation": "FOUNDATION",
  "plan.name.enterprise": "ENTERPRISE",
  "register.emailPlaceholder": "you@email.com",
  "invitation.top.loading": "Ładowanie najczęściej zapraszanych osób...",
  "invitation.top.empty": "Nie ma jeszcze polecanych zaproszonych osób.",
  "invitation.contacts.title": "Zaproś kontakty",
  "invitation.contacts.safe_phase_note": "Faza bezpieczna aktywna: oczekujące świadczenia bez wpływu na realne limity.",
  "invitation.contacts.generate_code": "Wygeneruj kod/link",
  "invitation.contacts.refresh_top3": "Odśwież Top 3",
  "invitation.contacts.hide_full_ranking": "Ukryj pełny ranking",
  "invitation.contacts.show_full_ranking": "Pokaż pełny ranking",
  "invitation.contacts.hide_metrics_dashboard": "Ukryj panel metryk",
  "invitation.contacts.show_metrics_dashboard": "Pokaż panel metryk",
  "invitation.contacts.prepared_link_label": "Przygotowany link:",
  "invitation.contacts.email_placeholder": "e-mail@domena.com",
  "invitation.contacts.register_pending": "Zarejestruj się w oczekiwaniu na zaproszenie",
  "invitation.contacts.status_summary": "Podsumowanie stanu",
  "invitation.contacts.sent_invitations": "Wysłane zaproszenia",
  "invitation.contacts.invited_email": "Zaproszony e-mail",
  "invitation.contacts.code": "kod",
  "invitation.contacts.no_sent_invitations": "Nie wysłałem jeszcze zaproszeń.",
  "invitation.contacts.simulated_rewards": "Uzyskane symulowane nagrody",
  "invitation.contacts.no_simulated_rewards": "Nie ma jeszcze symulowanych nagród.",
  "common.id": "ID",
  "common.created": "Stworzony",
  "plan.pro_contacts": "Hasta 100 contactos por usuario",
  "common.status": "Status",
  'login.prompt_create_account_with_name': 'Czy chcesz utworzyć konto z tą nazwą?',
  'auth.pending_activation.title': 'Konto oczekuje na aktywację',
  'auth.pending_activation.body': 'Twoje konto nie jest jeszcze aktywowane. Sprawdź skrzynkę i potwierdź rejestrację, aby zalogować się do ArChat.',
  'auth.pending_activation.back_to_login': 'Powrót do logowania',
  'auth.pending_activation.support_prefix': 'Potrzebujesz pomocy? Skontaktuj się z pomocą techniczną:',
  "auth.pending_activation.support_email": "info@archat.com.ar",
  'auth.pending_activation.email_label': 'E-mail do ponownej wysyłki aktywacji',
  'auth.pending_activation.email_placeholder': 'ty@email.com',
  'auth.pending_activation.email_required': 'Wpisz adres e-mail użyty przy rejestracji, aby ponownie wysłać aktywację.',
  'auth.pending_activation.sent_title': 'Wysłano e-mail aktywacyjny',
  'auth.pending_activation.sent_body': 'Jeśli adres pasuje do konta oczekującego, wysłaliśmy nowy link aktywacyjny. Sprawdź skrzynkę i spam.',
  'auth.pending_activation.soft_error_title': 'Ponowna wysyłka niedostępna',
  'auth.pending_activation.soft_error_body': 'Nie mogliśmy teraz przetworzyć ponownej wysyłki. Spróbuj ponownie za kilka minut lub skontaktuj się z nami pod adresem info@archat.com.ar.',
  'auth.pending_activation.resend_again': 'Wyślij ponownie',
  "plans.upgrade.title": "Zaktualizuj plan",
  "plans.upgrade.comparison": "Porównanie planów",
  'plans.upgrade.billing': '',
  "plans.upgrade.cancel_anytime": "Anuluj, kiedy tylko chcesz",
  "plans.actions.upgrade_pro": "Przejdź na PRO",
  "plans.actions.become_founder": "Zostań założycielem",

  'plans.modal.card.current_badge': 'Twój obecny plan',

  'plans.modal.card.lower_tier': 'Poniżej Twojego aktywnego planu',

  'plans.modal.card.manage_in_profile': 'Aby zmienić lub anulować: Subskrypcja i rozliczenia w profilu.',
                'plans.modal.card.cancel_subscription': 'Anuluj subskrypcję',
                'plans.modal.cancel_confirm.title': 'Anuluj lub zarządzaj subskrypcją',
                'plans.modal.cancel_confirm.body': 'Otworzy się nowa karta z bezpiecznym portalem Paddle, aby zaktualizować płatność, faktury lub anulować subskrypcję.',
                'plans.modal.cancel_confirm.continue_button': 'Dalej',
                'plans.modal.cancel_confirm.back_button': 'Wstecz',
                'plans.modal.cancel_paddle_fallback.title': 'Zarządzaj subskrypcją',
                'plans.modal.cancel_paddle_fallback.body': 'Portal rozliczeniowy Paddle nie otwiera się w tym środowisku (np. lokalnie lub bez powiązania). Nadal możesz przeglądać i porównywać plany na tej stronie.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Rozumiem',
  "plans.upgrade_required": "Dostępne w planie PRO",
  'settings.heading': 'Ustawienia',
  'settings.dashboard': 'Pulpit',
  'settings.dashboardDescription': 'Lokalne ustawienia panelu startowego i widocznych kafelków.',
  'settings.dashboardGridHeading': 'Kafelki panelu',
  'settings.dashboardShowOnStartDescription': 'Gdy włączone, po logowaniu otwiera się pulpit zamiast listy kontaktów.',
  'settings.dashboardBlockWelcome': 'Powitanie',
  'settings.dashboardBlockUsage': 'Użycie planu',
  'settings.dashboardBlockFiles': 'Moje pliki',
  'settings.dashboardBlockPromotions': 'Promocje',
  'settings.dashboardBlockSessions': 'Sesje',
  'settings.dashboardWelcomeDescription': 'Pierwsze kroki, zaproszenie kontaktu i skróty pomocy.',
  'settings.dashboardUsageDescription': 'Użycie a limity: kontakty, znaki, pamięć, urządzenia.',
  'settings.dashboardFilesDescription': 'Podsumowanie widocznych plików i miejsca w Moje pliki.',
  'settings.dashboardPromotionsDescription': 'Skrót promocji i link do programu.',
  'settings.dashboardSessionsDescription': 'Aktywne sesje i urządzenia; zamknięcie innych, jeśli możliwe.',
  'settings.enabled': 'Wł.',
  'settings.disabled': 'Wył.',
  'settings.showDashboardOnStart': 'Pokazuj pulpit po zalogowaniu',
  'settings.showWelcomeBlock': 'Blok powitalny',
  'settings.showPromotionsBlock': 'Blok promocji',
  'settings.showUsageBlock': 'Użycie planu',
  'settings.showRecentConversationsBlock': 'Pokaż ostatnie rozmowy (ostatnia wiadomość per kontakt)',
  'settings.showSessionsBlock': 'Aktywne sesje',
  'settings.showFilesBlock': 'Podsumowanie plików',
  'settings.dashboardLocalNote': 'Preferencje są lokalne w tej przeglądarce, do czasu API profilu.',
  'settings.appearanceSettings': 'Wygląd',
  'settings.argentinaTheme': 'Motyw Argentyna',
  'settings.darkMode': 'Tryb ciemny',
  'settings.language': 'Język',
  'settings.messageSound': 'Dźwięk wiadomości',
  'settings.playSoundDescription': 'Odtwarzaj dźwięk przy nowych wiadomościach lub ważnych alertach.',
  'settings.messageSoundEnabled': 'Włączone',
  'settings.messageSoundDisabled': 'Wyłączone',
  'settings.accountSettings': 'Konto',
  'settings.deleteAccount': 'Usuń konto',
  'settings.deleteAccountWarning': 'To jest trwałe. Twoje dane, wiadomości, kontakty i ustawienia zostaną usunięte zgodnie z procedurą platformy.',
  'settings.deleteMyAccount': 'Usuń moje konto',
  'dashboard.contacts': 'Kontakty',
  'dashboard.characters': 'Znaki',
  'dashboard.storage': 'Pamięć',
  'dashboard.active_devices': 'Aktywne urządzenia',
  'dashboard.need_more_resources': 'Potrzebujesz więcej zasobów?',
  'dashboard.upgrade_message': 'Ulepsz plan, aby uzyskać więcej kontaktów, znaków, pamięci i aktywnych urządzeń.',
  'dashboard.upgrade_button': 'Przejdź na PRO',
  'dashboard.upgrade_button_pro': 'Przejdź na PRO',
  'dashboard.upgrade_button_foundation': 'Przejdź na FOUNDATION',
  'files.preview': 'Podgląd',
  'files.previewFile': 'Podgląd pliku',
  'files.previewUnavailable': 'Podgląd niedostępny.',
  'files.previewLoading': 'Wczytywanie podglądu…',
  'files.openPreview': 'Podgląd',
  'files.downloadFile': 'Pobierz plik',
  'files.downloadFailed': 'Nie udało się pobrać pliku. Sprawdź połączenie i sesję, spróbuj ponownie.',
  'files.closePreview': 'Zamknij podgląd',
  'files.unsupportedPreview': 'Brak podglądu dla tego typu pliku. Możesz zobaczyć szczegóły lub pobrać plik.',
  'files.pdfPreviewHelp': 'Przeglądarka może nie wyświetlać osadzonego pliku PDF. Użyj pobierania, aby otworzyć.',
  'files.labelFileType': 'Typ',
  'files.previewForbidden': 'Brak uprawnień do podglądu.',
  'files.previewNotFound': 'Plik niedostępny lub niewidoczny na koncie.',
  'files.unavailableForFree': 'Moje pliki nie jest w planie FREE.',
  'files.availableInFoundationAndPro': 'Moje pliki jest dostępne w planach FOUNDATION i PRO.',
  'files.filesFeatureRestricted': 'Ta funkcja jest niedostępna w Twoim obecnym planie.',
  'files.filesLoadError': 'Błąd ładowania plików.',
  'files.uploadUnavailableForFree': 'Wysyłanie plików nie jest dostępne w planie FREE.',
  'files.uploadAvailableInFoundationAndPro': 'Wysyłanie plików jest dostępne w FOUNDATION i PRO.',
  'files.recipientStorageFull': 'Odbiorca nie ma wolnego miejsca, aby otrzymać ten plik.',
  'files.recipientNoAvailableStorage': 'Odbiorca nie ma wolnego miejsca, aby otrzymać ten plik.',
  'files.storageQuotaExceeded': 'Osiągnąłeś limit miejsca w swoim planie.',
  'files.freeStorageLimit': 'Plan FREE obejmuje 5 MB miejsca na otrzymane pliki.',
  'settings.unreadEmailReminderSection': 'Podsumowanie nieprzeczytanych e-mailem',
  'settings.unreadEmailReminderDescription': 'Jeśli nowe wiadomości lub pliki pozostaną nieprzeczytane dłużej niż poniżej, ArChat wyśle jedno zbiorcze podsumowanie (nie osobno na każdą wiadomość).',
  'settings.unreadEmailReminderToggle': 'Wysyłaj mi podsumowania e-mailem',
  'settings.unreadEmailDelayHours': 'Czas oczekiwania przed wysłaniem (godziny)',
  'settings.unreadEmailDelayHint': '1–168 godzin (do tygodnia). Język e-maila z profilu.',
  'subjects.title': 'Wątki',
  'subjects.singular': 'Wątek',
  'subjects.plural': 'Wątki',
  'subjects.general': 'Ogólny',
  'subjects.new': 'Nowy wątek',
  'subjects.create': 'Utwórz wątek',
  'subjects.rename': 'Zmień nazwę',
  'subjects.finish': 'Zakończ',
  'subjects.reopen': 'Otwórz ponownie',
  'subjects.select': 'Kontynuuj',
  'subjects.status.open': 'Otwarty',
  'subjects.status.pending': 'Oczekujący',
  'subjects.status.finished': 'Zakończony',
  'subjects.limitReached': 'Osiągnięto limit aktywnych wątków w tej rozmowie. Zakończ wątek, aby utworzyć kolejny.',
  'subjects.limitReachedFree': 'Plan FREE: do 3 aktywnych wątków na rozmowę. Zakończ wątek, aby utworzyć kolejny.',
  'subjects.limitReachedPro': 'Plan PRO: do 5 aktywnych wątków na rozmowę. Zakończ wątek, aby utworzyć kolejny.',
  'subjects.limitReachedFoundation': 'Plan FOUNDATION: do 5 aktywnych wątków na rozmowę. Zakończ wątek, aby utworzyć kolejny.',
  'subjects.activeLimitsLine': 'Aktywne wątki: {current} / {max}',
  'subjects.closedListTitle': 'Zamknięte wątki',
  'subjects.viewClosed': 'Zobacz zamknięte wątki',
  'subjects.noClosedSubjects': 'Brak zamkniętych wątków.',
  'subjects.reopenSubject': 'Otwórz ponownie',
  'subjects.reopenedSubjects': 'Ponownie otwarte wątki',
  'subjects.reopenLimitReached':
    'Osiągnięto limit aktywnych wątków. Zakończ inny wątek, aby otworzyć ten ponownie.',
  'subjects.ownerOnlyReopen': 'Tylko osoba, która utworzyła ten wątek, może go ponownie otworzyć.',
  'subjects.modal.title': 'Wątki rozmowy',
  'subjects.modal.subtitle': 'Wybierz lub zarządzaj tematami tej rozmowy.',
  'subjects.contactLabel': 'KONTAKT:',
  'subjects.ownerOnlyRename': 'Tylko twórca wątku może zmienić jego nazwę.',
  'subjects.ownerOnlyStateChange': 'Tylko twórca wątku może zmienić jego status.',
  'subjects.createdByOther': 'Ten wątek utworzyła druga strona. Możesz odpowiadać, ale nie zmienisz nazwy.',
  'subjects.empty': 'Brak wątków do wyświetlenia.',
  'subjects.noResults': 'Nie znaleziono wątków.',
  'subjects.error.generic': 'Nie udało się dokończyć akcji. Spróbuj ponownie.',
  'subjects.error.featureDisabled': 'Wątki są niedostępne w tym środowisku.',
  'subjects.error.duplicateName': 'Aktywny temat o tej nazwie już istnieje.',
  'subjects.error.ownerRequired': 'Nie masz uprawnień do modyfikacji tego wątku.',
  'subjects.error.defaultCannotRename': 'Wątek Ogólny nie może zostać przemianowany.',
  'subjects.error.defaultCannotFinish': 'Wątek Ogólny nie może zostać zakończony.',
  'subjects.current': 'Temat',
  'subjects.change': 'Zmień temat',
  'subjects.currentLabel': 'Temat:',
  'subjects.changeSubject': 'Zmień temat',
  'subjects.closedCannotSend': 'Ten temat jest zakończony. Otwórz go ponownie, aby wysłać nowe wiadomości.',
  'subjects.selectBeforeSend': 'Wybierz temat w oknie, aby wyświetlić wiadomości i wysyłać.',
  'subjects.loadingMessages': 'Ładowanie wiadomości dla tego tematu…',
  'subjects.messageFilterError': 'Nie udało się wczytać wiadomości dla tego tematu.',
  ...PRESET_LOCALES.pl,
  "auth.login.clear_password_lock_after_reset": "Zmieniłem już hasło (np. na innym urządzeniu)",
  "auth.signup_disabled": "Rejestracja nowego konta jest tymczasowo wyłączona w tym środowisku.",
  "auth.reset_user_not_found": "Nie znaleźliśmy konta powiązanego z tym adresem e-mail. Sprawdź, czy jest on wpisany poprawnie, lub utwórz nowe konto.",
  "account.not_found": "Nie znaleziono konta.",
  "menu.plans": "Plany",
  "files.title": "moje pliki",
  "files.filter_all": "Wszystko",
  "files.filter_sent": "Wysłano",
  "files.filter_received": "Otrzymane",
  "files.filter_images": "Obrazy",
  "files.filter_documents": "Dokumenty",
  "files.col_name": "Nazwa",
  "files.col_size": "Rozmiar",
  "files.col_date": "Data",
  "files.col_direction": "reż.",
  "files.col_actions": "Działania",
  "files.sent": "📤Wysłane",
  "files.received": "📥 Otrzymane",
  "files.download": "Wypisać",
  "files.delete_for_me": "Usuń dla mnie",
  "files.delete_confirm_title": "Usuń plik",
  "files.delete_confirm_message": "Ten plik zostanie usunięty z Twojego konta. Nie zostanie ono usunięte dla drugiej osoby. Kontynuować?",
  "files.empty": "Nie masz plików.",
  "files.error_loading": "Błąd przesyłania plików.",
  "files.load_more": "Załaduj więcej",
  "message.status.sending": "Przesyłka…",
  "message.status.failed": "Nie wysłano",
  "message.status.sent": "Wysłano",
  "message.status.delivered": "Dostarczony",
  "message.status.read": "Czytać",
  "home.public_nav.pricing": "Ceny",
  "home.public_nav.aria": "Główna nawigacja serwisu",
  "home.public_footer.aria": "Linki prawne",
  "home.pricing_link": "Plany i ceny",
  "publicPricing.nav.back_home": "← Strona główna",
  "publicPricing.title": "Plany i ceny",
  "publicPricing.subtitle": "Przejrzyste i dostosowane limity silnika subskrypcji ArChat. Ceny komercyjne w USD dla transakcji międzynarodowych (np. Paddle).",
  "publicPricing.commercial_note": "Granice funkcjonalne pochodzą z PlanConstants/PlanResolver; Twoje konto może zastosować plan_limits w bazie danych. Sprzedawcy pobierają opłaty za korzystanie z Paddle (lub innych procesorów oficjalnie wyznaczonych przez ArChat) z cenami w USD, jak wskazano.",
  "publicPricing.plan.free": "FREE",
  "publicPricing.plan.foundation": "FOUNDATION",
  "publicPricing.plan.pro": "PRO",
  "publicPricing.price.free": "USD 0 / mes",
  "publicPricing.price.foundation": "USD {price} / mes",
  "publicPricing.price.pro": "USD {price} / mes",
  "publicPricing.same_limits_pro": "Te same ograniczenia techniczne co PRO (umowa premium).",
  "publicPricing.same_limits_foundation": "Takie same ograniczenia techniczne jak FOUNDATION (umowa premium).",
  "publicPricing.badge.foundation": "Programa Founder",
  "publicPricing.badge.pro": "Recomendado",
  "publicPricing.free.b1": "30 000 znaków miesięcznie na konto.",
  "publicPricing.free.b2": "Do 2 kontaktów na użytkownika; do 2 aktywnych rozmów na konto.",
  "publicPricing.free.b3": "Brak załączników i miejsca do przechowywania; bez eksportu danych.",
  "publicPricing.free.b4": "Historia wiadomości do 30 dni; 1 urządzenie na użytkownika.",
  "publicPricing.free.b5": "34 wiadomości/dzień i 1000 wiadomości/miesiąc (najemca); do 20 zaproszeń dziennie.",
  "publicPricing.premium.b1": "300 000 znaków miesięcznie na konto; do 100 kontaktów na użytkownika.",
  "publicPricing.premium.b2": "Nielimitowane rozmowy i czaty (najemca); 1667 wiadomości dziennie i 50 000 miesięcznie.",
  "publicPricing.premium.b3": "Do 50 MB przestrzeni dyskowej (najemca); do 3 urządzeń na użytkownika.",
  "publicPricing.premium.b4": "Nielimitowane zaproszenia (najemca); eksport, automatyczne tłumaczenie i pliki zgodnie z planem.",
  "publicPricing.premium.b5": "FUNDACJA: taki sam kontrakt techniczny jak PRO, plus program Founder (150 miejsc). PRO: standard premium.",
  "publicPricing.foundation.founder_note": "Założyciel programu komercyjnego: ograniczona liczba miejsc (sloty) (patrz podsumowanie planu). Te same limity PRO po aktywowaniu subskrypcji.",
  "publicPricing.cta.start_free": "Utwórz darmowe konto",
  "publicPricing.cta.register_paid": "Utwórz konto",
  "publicPricing.paddle_hint": "Zamówienie z wybranym procesorem zostanie zrealizowane w aplikacji po włączeniu ładowania.",
  "publicPricing.legal.nav_label": "Prawny",
  "publicPricing.legal.terms": "Warunki usługi",
  "publicPricing.legal.privacy": "Polityka prywatności",
  "publicPricing.legal.refund": "Polityka zwrotów",
  "profile.security.privacy_note": "Zarządzaj prywatnością i bezpieczeństwem swojego konta.",
  "profile.security.sessions_title": "Aktywne sesje",
  "profile.security.current": "Bieżąca sesja",
  "profile.plan.foundation.description": "Plan FOUNDATION (Founder): takie same funkcje premium jak PRO, z programem Founder i ograniczoną przestrzenią (150 miejsc).",
  "billing.view_plans": "Zobacz plany",
  "billing.paddle.cancel_via_portal": "Anuluj subskrypcję",
  "billing.paddle.test_access_denied_body": "Na tym serwerze operacje rozliczeniowe są ograniczone (tryb testowy lub lista testowa). Jeśli zapłaciłeś już za pomocą konta rzeczywistego, w wersji produkcyjnej płatność musi być dozwolona dla wszystkich użytkowników (np. PAYMENTS_ALLOW_ALL_BILLING_USERS) lub to ograniczenie musi być wyłączone. Skontaktuj się z pomocą techniczną.",
  "attachment.storage_insufficient_precheck.title": "Niewystarczająca przestrzeń",
  "attachment.storage_insufficient_precheck.message": "Plik waży {fileSizeMb} MB, a Ty masz dostępne tylko {availableMb} MB. Zwolnij miejsce lub ulepsz swój plan, aby kontynuować.",
  "attachment.files_disabled.title": "Limit planu",
  "attachment.files_disabled.message": "Twój obecny plan nie obejmuje wysyłania plików. Popraw swój plan, aby kontynuować.",
  "contacts.viewContactInfo": "Zobacz dane kontaktowe",
  "contacts.contactInfoTitle": "Dane kontaktowe",
  "contacts.phone": "Telefon",
  "contacts.bio": "Biografia",
  "contacts.notProvided": "Niedoinformowany",
  "contacts.unread.badge": "Nieprzeczytane wiadomości",
  "dashboard.recentInbound.title": "Ostatnie otrzymane wiadomości",
  "dashboard.recentInbound.empty": "Nie masz ostatnio otrzymanych wiadomości.",
  "dashboard.recentInbound.error": "Nie udało się załadować wiadomości.",
  "dashboard.recentInbound.previewPhoto": "Zdjęcie",
  "dashboard.recentInbound.previewFile": "Archiwum",
  "dashboard.recentInbound.previewPdf": "PDF",
  "dashboard.recentInbound.previewUnavailable": "Wiadomość niedostępna",
  "dashboard.recentInbound.readTitle": "Czytać",
  "dashboard.recentInbound.unreadTitle": "niewykształcony",
  "dashboard.recentConversations.title": "Ostatnie rozmowy",
  "dashboard.recentConversations.empty": "Brak rozmów do pokazania.",
  "dashboard.recentConversations.error": "Nie udało się wczytać rozmów.",
  "dashboard.plan.foundation": "FOUNDATION",
  "plan.errors.translationNotAllowed.title": "Tłumaczenie niedostępne",
  "plan.errors.translationNotAllowed.message": "Twój obecny plan nie obejmuje automatycznego tłumaczenia między językami.",
  "plan.errors.translationNotAllowed.solution": "Aby korzystać z automatycznego tłumaczenia, uaktualnij swój plan.",
  "billing.subscription.cancel_scheduled_date": "Twoja subskrypcja zostanie anulowana w dniu {{date}}. Do tego czasu możesz nadal korzystać ze swojego planu.",
  "billing.subscription.cancel_scheduled_badge": "Anulowano w dniu {{date}}",
  "billing.scheduled.plan_after_cancel_label": "Zaplanuj na koniec okresu:",
  "billing.scheduled.plan_free": "FREE (gratuito)",
  "billing.scheduled.plan_foundation": "FOUNDATION",
  "billing.scheduled.switch_to_foundation": "Zmień na PODKŁAD",
  "billing.scheduled.switch_to_free": "Zmień na BEZPŁATNE",
  "billing.scheduled.foundation_full_title": "PODKŁAD niedostępny",
  "billing.scheduled.foundation_full_message": "W tej chwili nie ma wolnych miejsc FOUNDATION. Pod koniec tego okresu Twój plan zostanie zmieniony na BEZPŁATNY.",
  "billing.scheduled.saving": "Oszczędność...",
  "billing.scheduled.error_title": "Błąd podczas zmiany planu",
  "billing.scheduled.error_generic": "Zaplanowanego planu nie można było zmienić. Spróbuj ponownie.",
  "billing.cancel_scheduled.title": "Zaplanowane anulowanie",
  "billing.cancel_scheduled.desc": "Twoja subskrypcja zostanie anulowana {{date}}. Do tego czasu możesz nadal korzystać z obecnego planu.",
  "billing.cancel_scheduled.no_new_plan_until_end": "Dopóki ta subskrypcja nie wygaśnie, nie będziesz mógł zawrzeć umowy na kolejny plan.",
  "billing.cancel_scheduled.free_fallback": "Jeśli nie odnowisz żadnego planu, Twoje konto będzie kontynuowane BEZPŁATNIE z odpowiednimi ograniczeniami.",
  "billing.cancel_scheduled.profile_deactivation_hint": "Możesz także zrezygnować z subskrypcji platformy ze swojego profilu.",
  "billing.cancel_scheduled.default_free": "Na koniec okresu: BEZPŁATNIE",
  "google.missing_client_id": "Logowanie Google nie jest dostępne w tej kompilacji: brakuje VITE_GOOGLE_CLIENT_ID (lub googleClientId na dzierżawcę w __ARCHAT_TENANT_CONFIG__).",
  "reviews.title": "Recenzje ArChata",
  "reviews.create_title": "Jak oceniasz ArChat?",
  "reviews.edit_title": "Edytuj moją recenzję",
  "reviews.comment_placeholder": "Opowiedz nam o swoim doświadczeniu (opcjonalnie)...",
  "reviews.submit_btn": "Prześlij recenzję",
  "reviews.update_btn": "Aktualizacja",
  "reviews.thank_you": "Dziękujemy za opinię!",
  "reviews.submitted_message": "Twoja opinia pomaga nam się udoskonalać.",
  "reviews.error_select_rating": "Wybierz ocenę",
  "reviews.error_generic": "Błąd podczas przesyłania recenzji",
  "reviews.prompt_message": "Czy podoba Ci się ArChat? Zostaw swoją opinię!",
  "reviews.rate_now": "Zakwalifikować",
  "reviews.later": "Później",
  "reviews.write_review": "Napisz recenzję",
  "reviews.edit_my_review": "Edytuj moją recenzję",
  "reviews.no_reviews": "Nie ma jeszcze żadnych recenzji. Bądź pierwszy!",
  "reviews.review_singular": "recenzja",
  "reviews.review_plural": "recenzje",
  "reviews.verified": "Zweryfikowano",
  "reviews.anonymous": "Anonimowy",
  "files.storageUsed": "Wykorzystana przestrzeń",
  "files.planQuota": "Limit planu",
  "files.availableStorage": "Dostępny",
  "files.usagePercent": "używany",
  "files.unlimited": "Nieograniczony",
  "files.sentBy": "Wysłane przez",
  "files.unknownUser": "Użytkownik",
  "settings.webPushSection": "Powiadomienia systemowe (push/PWA)",
  "settings.webPushDescription": "Zezwala na powiadomienia, gdy aplikacja działa w tle lub jest zamknięta na urządzeniu mobilnym. Wymaga klucza publicznego VAPID w kompilacji (VITE_VAPID_PUBLIC_KEY) i kluczy na serwerze. Aktywuj uprawnienia przeglądarki i zarejestruj to urządzenie.",
  "settings.webPushButton": "Aktywuj powiadomienia push",
  "settings.webPushRegistering": "Rejestracyjny…",
  "settings.webPushState.granted": "Pozwolenie udzielone. Jeżeli VAPID jest ustawiony prawidłowo, log został wysłany na serwer.",
  "settings.webPushState.denied": "Odmowa pozwolenia. Włącz powiadomienia dla tej witryny w ustawieniach swojej przeglądarki.",
  "settings.webPushState.default": "Naciśnij przycisk, aby poprosić o pozwolenie i zarejestrować urządzenie.",
  "settings.webPushState.unsupported": "Ta przeglądarka nie obsługuje powiadomień push.",
  "settings.webPushVapidMissing": "W tej kompilacji frontonu brakuje VITE_VAPID_PUBLIC_KEY: nie można ukończyć subskrypcji push.",
  "tags.etiquetas": "etykiety",
  "tags.manageTitle": "Zarządzaj tagami",
  "tags.manage": "🏷️ Tagi",
  "tags.allTags": "Wszystkie tagi",
  "tags.confirmDelete": "Usunąć ten tag?",
  "tags.tagNamePlaceholder": "Nazwa znacznika",
  "tags.create": "Tworzyć",
  "tags.noTags": "Nie ma żadnych etykiet. Utwórz jeden powyżej.",
  "tags.save": "Trzymać",
  "tags.edit": "Redagować",
  "tags.delete": "Wyeliminować",
  "tags.assignTo": "Przypisz do",
  "tags.noTagsToAssign": "Brak dostępnych etykiet. Najpierw je utwórz.",
  "tags.bgColor": "kolor tła",
  "tags.textColor": "Kolor tekstu",
  "tags.selectTag": "Wybierz etykietę",
  "templates.selectTitle": "Szablony",
  "templates.noTemplates": "Brak szablonów. Utwórz jeden powyżej.",
  "templates.manage": "Zarządzaj szablonami",
  "templates.confirmDelete": "Usunąć ten szablon?",
  "templates.manageTitle": "Zarządzaj szablonami",
  "templates.titlePlaceholder": "Tytuł szablonu",
  "templates.bodyPlaceholder": "Napisałem szablon wiadomości...",
  "templates.create": "Utwórz szablon",
  "templates.save": "Trzymać",
  "templates.edit": "Redagować",
  "templates.delete": "Wyeliminować",
};


